import React, { useState, useEffect } from "react";
import {
    Calendar,
    ChevronDown,
    ChevronUp,
    Trash2,
    Printer,
    X,
    Building2,
    FileCheck,
    Info,
    MapPin,
    Container,
    Search,
    Ship,
    PenLine,
    Send,
    FileCheck2,
    Receipt,
    Plus,
    Boxes,
    FolderOpen,
    Shield,
    UsersRound,
    ArrowLeft,
    Save,
    FileText,
    RefreshCw,
    ClipboardList,
    ClipboardCheck,
    Route,
    Anchor,
    Package,
    Truck,
    Warehouse,
    DollarSign,
    Paperclip,
    Edit2,
    User,
    ReceiptText,
    Eye,
} from "lucide-react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { SearchBar } from "../SearchBox/SearchBar";
import {
    getBookingDetails,
    addBookingDetails,
    updateBookingDetails,
    GetVesselSchedule,
} from "@/redux/Booking/actions";
import {
    getAddressAPI,
    getAddresswithfulldetail,
} from "@/redux/Purchase/actions";
import DateInputwithcal from "../ui/DateInputwithcal";
import DateTimeInputwithcal from "../ui/DateTimeInputwithcal";
import FileUpload from "../FileUpload/FileUpload";
import { validateForm } from "../ui/useFormValidation";
import UploadNotes from "../NotesUpload/NotesUpload";
import Validationbookingfrom from "@/validation/bookingfrom.json";
import { getClauselist } from "@/redux/Common/actions";
import { callLoader } from "@/redux/Loader/actions";
import DynamicSelect from "../ui/DynamicSelect";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import CelebrationButton from "../ui/CelebrationButton/CelebrationButton";
import { showToast } from "@/redux/Toast/actions";
import notificationService from "@/services/notificationService";
import ARAPChargesContainer from "./charges/ARAPChargesContainer";
import { Alert } from "../ui/VerticalStepper";
import PageHeader from "../FormHeader/formPageHeader";
import { InlineCountryFlag } from "../shipment/CountryBadge";

const BookingForm = ({ onBack, bookingData = null, onPrint }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        countryList,
        documentTypePurchaseList,
        documentTypeSalesList,
        incoTermsList,
        quantityTypeList,
        salesPersonList,
        uomTypeList,
        commodityGroupList,
        containerTypeList,
        operatorList,
        moveTypeList,
        currency_list,
        charges_basis_list,
        fileManagerList,
    } = useSelector((state) => state.common);

    const [formData, setFormData] = useState();
    const [items, setItems] = useState([]);
    const [transshipPorts, setTransshipPorts] = useState([]);
    const [charges, setCharges] = useState([]);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [errors, setErrors] = useState({});
    const [cargoItems, setCargoItems] = useState([]);
    const [dateErrors, setDateErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [clauses, setClauses] = useState([]);
    const [originalFormClauses, setOriginalFormClauses] = useState([]);
    const [authUser] = JSON.parse(localStorage.getItem("authUser") ?? "[{}]");

    const { isAnimate } = useSelector((state) => state.toast);
    const { loader } = useSelector((state) => state.loader);
    const companyId = authUser?.companyId;
    const username = authUser?.username;

    // AR/AP Charges State
    const [arCharges, setArCharges] = useState([]);
    const [apCharges, setApCharges] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [vesselList, setVesselList] = useState([]);

    useEffect(() => {
        if (bookingData != 0 && bookingData != null) {
            _getBooking();
            
        } else {
            _setNewBooking();
        }
    }, [bookingData]);

    const formatDate = (date) =>
        date ? new Date(date).toISOString().split("T")[0] : "";

    // booking js start
    const initialBooking = {
        totalNum: 0,
        rowNum: 0,
        id: 0,
        companyId: 0,
        customerId: 0,
        customerName: "",
        contactName: "",
        telephone: "",
        fax: "",
        email: "",
        operatorId: 0,
        operatorName: "",
        blModeId: 0,
        blMode: "",
        officeTypeId: 1,
        officeType: "",
        fileNumber: "",
        carrierBookingNumber: "",
        customerReference: "",
        shippingType: "",
        salesOrder: "",
        shipment: "",
        carrierB: "",
        invoice: "",
        shipperId: 0,
        shipper: "",
        shipperAddress: "",
        notifyId: 0,
        notify: "",
        notifyAddress: "",
        consigneeId: 0,
        consignee: "",
        consigneeAddress: "",
        alsoNotifyId: 0,
        alsoNotify: "",
        alsoNotifyAddress: "",
        carrierMoveType: "",
        ourMoveType: "PORT TO PORT",
        ourPlaceOfReceipt: "",
        carrierPlaceOfReceipt: "",
        portOfLoading: "",
        portOfLoadingCode: "",
        portOfDischarge: "",
        portOfDischargeCode: "",
        carrierPlaceOfDelivery: "",
        ourPlaceOfDelivery: "",
        countryOfDestination: "",
        carrier: "",
        carrierCode: "",
        hodeCarrier: false,
        carrierContractNumber: "",
        vessel: "",
        vesselCode: "",
        voyage: "",
        voyageCode: "",
        ourDocCo: null, // dates can be null
        vgmCo: null,
        sslDocCo: null,
        earliestPickupDate: null,
        earliestRecvdDate: null,
        autoCo: null,
        titleCutOff: null,
        inlandEailCo: null,
        portCo: null,
        etsAtOrigin: null,
        etsAtPol: null,
        etaAtPod: null,
        etaAtDestination: null,
        commodityGroupId: "0",
        commodityGroup: "",
        commodity: "",
        hsCodes: "",
        hazCargo: false,
        hazImoClass: "",
        hazPkg: "",
        hazUnNbr: "",
        weight: "0",
        weightMetricId: "0",
        weightMetricType: "",
        clausesType: "",
        documentRequestToCustomer: false,
        showAutoBoatClause: false,
        containerCount: 0,
        containerTypeId: "0",
        containerType: "",
        reeferContainerTemperature: "0",
        tempUom: "",
        ventStatus: "",
        ventRemark: "",
        reeferEquipmentAttributes: "",
        railTrackingRequired: false,
        paymentModeType: "",
        paymentMode: "",
        truckerId: 0,
        trucker: "",
        hideTruckerOnBookingPrint: false,
        truckerApptConfirmed: false,
        rateAgreed: "",
        rateAgreedForWaiting: "",
        truckerContainerCount: 0,
        truckerContainerTypeId: "0",
        truckerContainerType: "",
        truckerEmptyContainerPickupId: "0",
        truckerEmptyContainerPickup: "",
        truckerEmptyContainerPickupAddress: "",
        truckerEarliestPickup: null,
        truckerEarliestRecvd: null,
        truckerLatestDeliveryDate: null,
        truckerContainerReturnToId: "0",
        truckerContainerReturnTo: "",
        truckerContainerReturnToAddress: "",
        cargoDescription: "",
        warehouseInstructionsRemarks: "",
        loadingStatus: "",
        liveLoadDate: null,
        dropDate: null,
        pickupDate: null,
        loadingLocationWarehouseId: "0",
        loadingLocationWarehouse: "",
        loadingLocationWarehouseAddress: "",
        loadingLocationWarehouseContactPerson: "",
        loadingLocationWarehouseTelFax: "",
        loadingRemarksForTrucker: "",
        truckerPoc: "",
        truckerPhone: "",
        truckerEmail: "",
        overseasAgentId: 0,
        overseasAgent: "",
        overseasAgentAddress: "",
        overseasAgentRemarks: "",
        customerRemarks: "",
        internalRemarks: "",
        sslRemarks: "",
        rubberStamp: "",
        createdBy: "",
        createdOn: null,
        modifiedOn: null,
        modifiedBy: "",
        isActive: true,
        loadPlanId: 0,
        loadPlanNumber: "",
        warehouseId: 0,
        warehouseName: "",
        warehouseCode: "",
        warehouseAddress: "",
        warehouseContact: "",
        receivingDate: null,
        receivingTime: "",
        appointmentNumber: "",
        specialInstructions: "",
        letterOfCreditNumber: "",
        lcIssueDate: null,
        lcExpiryDate: null,
        insurancePolicyNumber: "",
        insuranceCompany: "",
        additionalNotes: "",
        totalPackageType: 0,
        packageType: "",
        rates: [
            {
                allIn: true,
                descriptions: "",
                currency: "",
                roe: 0,
                basis: "",
                contType: "",
                quantity: 0,
                sellAmount: 0,
                sellRate: 0,
                vendorId: null,
                vendorName: "",
                chrgBillToPartyId: null,
                chrgBillToPartyName: "",
                buyAmount: 0,
                buyRate: 0,
                paymentMode: "CASH",
                descCode: "DOC",
                isDeleted: false,
                printOnBl: true,
                printOnMbl: false,
                officeTypeAr: "HO",
                officeTypeAp: "HO",
                isCustAdditionalRate: 0,
                isDisputeAr: false,
                isDisputeAp: false,
                arPaid: false,
                apPaid: false,
                inventoryNumber: "",
            },
        ], // empty array
        transhipmentPorts: [],
        cargoDimensionDetails: [],
        clauses: [],
    };

    const _getBooking = async () => {
        try {
            dispatch(callLoader(1));
            const resultData = await dispatch(getBookingDetails(bookingData, companyId));
            // console.log("data will come:", resultData);
            setFormData(resultData);
            setTransshipPorts(resultData?.transhipmentPorts ?? []);
            setCharges(resultData?.rates ?? []);
            setCargoItems(resultData?.cargoDimensionDetails ?? [defaultCargoItem]);
            getClauselistData(resultData?.clauses || []);
            setOriginalFormClauses(resultData?.clauses || []);

            // Load AR/AP charges from formSnapshot or direct fields
            if (resultData?.formSnapshot) {
                const snapshot =
                    typeof resultData.formSnapshot === "string"
                        ? JSON.parse(resultData.formSnapshot)
                        : resultData.formSnapshot;
                setArCharges(snapshot.arCharges || []);
                setApCharges(snapshot.apCharges || []);
            } else {
                setArCharges(resultData?.arCharges || []);
                setApCharges(resultData?.apCharges || []);
            }

            setFormData((prev) => ({
                ...prev,
                modifiedBy: username,
                companyId: companyId,
            }));
            console.log("booking details fetched:", resultData);
        } catch (error) {
            // console.error("Error fetching booking details:", error);
            dispatch(showToast("Failed to load booking details", "error"));
            //toast.error("Failed to load booking details");
        } finally {
            dispatch(callLoader(0));
        }
    };

    const _setNewBooking = async () => {
        setFormData(initialBooking);
        setTransshipPorts([]);
        setCharges([]);
        setCargoItems([defaultCargoItem]);
        getClauselistData([]);
        setArCharges([]);
        setApCharges([]);
        setFormData({
            ...initialBooking,
            shippingType: "FCL",
            createdBy: username,
            companyId: companyId,
        });
        setCharges(initialBooking?.rates ?? []);
    };

    const [expandedSections, setExpandedSections] = useState({
        BookingRequestNumber: true,
        customer: true,
        blDirect: false,
        booking: true,
        routing: true,
        transship: false,
        commodity: true,
        loadPlan: true,
        Trucking: false,
        warehouse: true,
        arAp: true,
        agent: true,
        certificate: true,
        clause: true,
        remarks: true,
        reference: true,
        cargoDetails: false,
        warehouse: false,
        additionalInfo: true,
        documentsupload: true,
        NotesUpload: true,
        commonClause: true,
    });

    // Purchase Order lookup (mock) — shown inside Cargo Details section
    const [poNumber, setPoNumber] = useState("");
    const [poModalOpen, setPoModalOpen] = useState(false);
    const [poModalData, setPoModalData] = useState(null);
    const [poSelectedLoads, setPoSelectedLoads] = useState({});

    const MOCK_PO_DATABASE = {
        PO22101008: {
            poNumber: "PO22101008",
            items: [
                {
                    load: false,
                    description: "MACHINE001",
                    itemNo: 10,
                    totalItems: 200,
                    loaded: 200,
                    pending: 0,
                    readyToLoad: 0,
                    status: "DONE",
                },
                {
                    load: false,
                    description: "MACHINE002",
                    itemNo: 20,
                    totalItems: 350,
                    loaded: 350,
                    pending: 0,
                    readyToLoad: 0,
                    status: "DONE",
                },
            ],
        },
        PO22101009: {
            poNumber: "PO22101009",
            items: [
                {
                    load: false,
                    description: "AUTOPART-A",
                    itemNo: 11,
                    totalItems: 120,
                    loaded: 80,
                    pending: 40,
                    readyToLoad: 30,
                    status: "IN PROGRESS",
                },
                {
                    load: false,
                    description: "AUTOPART-B",
                    itemNo: 12,
                    totalItems: 90,
                    loaded: 0,
                    pending: 90,
                    readyToLoad: 0,
                    status: "PENDING",
                },
                {
                    load: false,
                    description: "AUTOPART-C",
                    itemNo: 13,
                    totalItems: 60,
                    loaded: 60,
                    pending: 0,
                    readyToLoad: 0,
                    status: "DONE",
                },
            ],
        },
        PO22101010: {
            poNumber: "PO22101010",
            items: [
                {
                    load: false,
                    description: "ELECTRONICS-1",
                    itemNo: 30,
                    totalItems: 500,
                    loaded: 250,
                    pending: 250,
                    readyToLoad: 150,
                    status: "IN PROGRESS",
                },
            ],
        },
    };

    const handleSearchPurchaseOrder = () => {
        const key = (poNumber || "").trim().toUpperCase();
        if (!key) {
            toast.error("Please enter a Purchase Order #");
            return;
        }
        const data = MOCK_PO_DATABASE[key] || {
            poNumber: key,
            items: [
                {
                    load: false,
                    description: "SAMPLE-ITEM-01",
                    itemNo: 10,
                    totalItems: 100,
                    loaded: 50,
                    pending: 50,
                    readyToLoad: 25,
                    status: "IN PROGRESS",
                },
                {
                    load: false,
                    description: "SAMPLE-ITEM-02",
                    itemNo: 20,
                    totalItems: 200,
                    loaded: 200,
                    pending: 0,
                    readyToLoad: 0,
                    status: "DONE",
                },
            ],
        };
        setPoModalData(data);
        setPoSelectedLoads({});
        setPoModalOpen(true);
    };

    const steps = [
        "Booking Details",
        "Customer Information",
        "Booking Request Number",
        "Shipper & Consignee Information",
        "Routing & Schedules",
        "Transhipment Ports",
        "Commodity Details",
        "Cargo Details (LCL/RO-RO)",
        "Trucking Instructions",
        "Warehouse Instructions",
        "Charges & Costings",
        "Document & Attachments",
        "Notes",
        "Clause",
        "Additional Info",
        "Overseas Agent and Others",
        "Review and Submit",
    ];

    const toggleSection = (section) => {
        setExpandedSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    // {🚅🚅🚅🚅 transport work start here }
    const addTransshipPort = () => {
        setTransshipPorts((prev) => [
            ...prev,
            {
                transPortId: 0,
                transPortCity: "",
                transEta: null,
                transActualDeparture: null,
                transVessel: "",
                transEtd: null,
                transVoyage: "",
                transActualArrival: null,
                isDeleted: false,
                createdBy:
                    `${authUser?.firstName ?? ""} ${authUser?.lastName ?? ""}`.trim(),
            },
        ]);
    };

    const handleTranshipPortChange = (index, field, value) => {
        const updated = [...transshipPorts];
        updated[index][field] = value;
        setTransshipPorts(updated);
    };
    // {🚅🚅🚅🚅 end  transport work start here }

    const addChargeRow = () => {
        setCharges((prev) => [
            ...prev,
            {
                allIn: true,
                descriptions: "",
                currency: "",
                roe: 0,
                basis: "",
                contType: "",
                quantity: 0,
                sellAmount: 0,
                sellRate: 0,
                vendorId: null,
                vendorName: "",
                chrgBillToPartyId: null,
                chrgBillToPartyName: "",
                buyAmount: 0,
                buyRate: 0,
                paymentMode: "CASH",
                descCode: "DOC",
                isDeleted: false,
                printOnBl: true,
                printOnMbl: false,
                officeTypeAr: "HO",
                officeTypeAp: "HO",
                isCustAdditionalRate: 0,
                isDisputeAr: false,
                isDisputeAp: false,
                arPaid: false,
                apPaid: false,
                inventoryNumber: "",
            },
        ]);
    };

    const handleRateChange = (index, field, value) => {
        const updated = [...charges];
        updated[index][field] = value;
        setCharges(updated);
        // console.log("charges updated:", value);
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
        console.log(
            "Input Changed:",
            name,
            "Value:",
            type === "checkbox" ? checked : value,
        );
    };

    // This function will be used only for onBlur validation
    const handleBlurValidation = (e, validationType = null) => {
        const { name, value, type, checked } = e.target;
        const finalValue = type === "checkbox" ? checked : value;

        if (validationType) {
            let errorMessage = "";

            if (finalValue !== "") {
                errorMessage = validateField(finalValue, validationType);
            }

            setErrors((prev) => ({
                ...prev,
                [name]: errorMessage,
            }));
        }

        // console.log('Blurred field:', name, 'Value:', finalValue, 'Validation Type:', validationType);
    };

    const validateField = (value, validationType) => {
        switch (validationType) {
            case "required":
                return value ? "" : "This field is required";

            case "number":
                return /^\d+$/.test(value) ? "" : "Only numbers allowed";

            case "email":
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
                    ? ""
                    : "Invalid email address";

            case "mobile":
                return /^\d{10}$/.test(value) ? "" : "Mobile number must be 10 digits";
            case "amount":
                return /^\d+(\.\d{1,2})?$/.test(value)
                    ? ""
                    : "Enter valid amount (up to 2 decimals)";

            default:
                return "";
        }
    };

    const _setAddress = async (type, id) => {
        const address = await getAddressAPI(id);
        setFormData((prev) => ({ ...prev, [`${type}`]: address }));
    };
    const getSalesPersonName = (id) => {
        return (
            salesPersonList?.find((v) => v.salesPersonId === id)?.salesPerson || ""
        );
    };
    const _getAddresswithfulldetail = async (type, id) => {
        try {
            const res = await getAddresswithfulldetail(id);
            // console.error('fetching address details:', res);
            const data = res?.data?.[0];
            if (!data) return;

            setFormData((prev) => ({
                ...prev,
                contactName: data.contactname || "",
                telephone: data.addressphno || "",
                email: data.email || "",
                salesPersonId: data?.salespersonid || "",
                salesPerson: getSalesPersonName(data?.salespersonid),
            }));
        } catch (error) {
            // console.error('Error fetching address details:', error);
        }
    };

    // {📅📅📅📅📅 date formData handlers YYYY-MM-DD}

    const handleDateChange = (name, value) => {
        setFormData((prev) => {
            const updatedData = {
                ...prev,
                [name]: value || null,
            };

            const validationErrors = validateDates(updatedData);

            // ✅ correct state setter
            setDateErrors(validationErrors);

            return updatedData;
        });
    };

    const handleDateError = (fieldName, hasError) => {
        setDateErrors((prev) => {
            const updated = {
                ...prev,
                [fieldName]: hasError || null,
            };

            // ✅ auto remove field if error is fixed
            if (!hasError) {
                delete updated[fieldName];
            }

            return updated;
        });
    };

    const validateDates = (data) => {
        const errors = {};

        const etsOrigin = data?.etsAtOrigin;
        const etsPol = data?.etsAtPol;
        const etaPod = data?.etaAtPod;
        const etaDestination = data?.etaAtDestination;

        const toDate = (d) => (d ? new Date(d) : null);
        const isValid = (d) => d instanceof Date && !isNaN(d.getTime());

        const o = toDate(etsOrigin);
        const p = toDate(etsPol);
        const pod = toDate(etaPod);
        const dest = toDate(etaDestination);

        // ETS Origin → ETS POL
        if (isValid(o) && isValid(p) && o > p) {
            errors.etsAtPol = "ETS at POL must be after ETS at Origin";
        }

        // ETS POL → ETA POD
        if (isValid(p) && isValid(pod) && p > pod) {
            errors.etaAtPod = "ETA at POD must be after ETS at POL";
        }

        // ETA POD → ETA Destination
        if (isValid(pod) && isValid(dest) && pod > dest) {
            errors.etaAtDestination = "ETA at Destination must be after ETA at POD";
        }

        return errors;
    };

    // {📅📅📅📅📅 end date formData handlers}

    // {🚛🚛🚛🚛🚛start CARGO DETAIL calculations and handlers}
    const defaultCargoItem = {
        piece: 0,
        length: 0,
        width: 0,
        height: 0,
        packageType: "",
        dimensionType: "METER",
        weightKgs: 0,
        cbm: 0,
        cft: 0,
        weightLbs: 0,
        createdBy:
            `${authUser?.firstName ?? ""} ${authUser?.lastName ?? ""}`.trim(),
        isDeleted: false,
    };

    // Add new cargo row
    const addCargoRow = () => {
        setCargoItems((prev) => [...prev, { ...defaultCargoItem }]);
    };

    // Remove cargo row
    const removeCargoRow = (index) => {
        const newItems = [...cargoItems];
        newItems[index].isDeleted = true;
        setCargoItems(newItems);
    };

    // Handle cargo item changes
    const handleCargoItemChange = (index, field, value) => {
        setCargoItems((prevItems) => {
            const newItems = [...prevItems];

            if (newItems[index]?.isDeleted) return prevItems;

            const updatedItem = {
                ...newItems[index],
                [field]: value,
            };

            if (formData?.autoCalculate !== false) {
                let length = parseFloat(updatedItem.length) || 0;
                let width = parseFloat(updatedItem.width) || 0;
                let height = parseFloat(updatedItem.height) || 0;

                if (updatedItem.dimensionType === "INCH") {
                    length *= 0.0254;
                    width *= 0.0254;
                    height *= 0.0254;
                } else if (updatedItem.dimensionType === "CM") {
                    length *= 0.01;
                    width *= 0.01;
                    height *= 0.01;
                }

                const piece = parseFloat(updatedItem.piece) || 1;

                const cbm = length * width * height * piece;

                const cft = cbm * 35.3147;

                const weightKgs = parseFloat(updatedItem.weightKgs) || 0;
                const weightLbs = weightKgs * 2.20462;

                updatedItem.cbm = cbm.toFixed(2);
                updatedItem.cft = cft.toFixed(2);
                updatedItem.weightLbs = weightLbs.toFixed(2);
            }

            newItems[index] = updatedItem;

            return newItems;
        });
    };

    // Calculate totals
    const activeItems = cargoItems.filter((item) => !item.isDeleted);

    const totalPieces = activeItems.reduce(
        (sum, item) => sum + (parseFloat(item.piece) || 0),
        0,
    );

    const totalWeightKgs = activeItems.reduce(
        (sum, item) => sum + (parseFloat(item.weightKgs) || 0),
        0,
    );

    const totalWeightLbs = activeItems.reduce(
        (sum, item) => sum + (parseFloat(item.weightLbs) || 0),
        0,
    );

    const totalVolumeCbm = activeItems.reduce(
        (sum, item) => sum + (parseFloat(item.cbm) || 0),
        0,
    );

    const totalVolumeCft = activeItems.reduce(
        (sum, item) => sum + (parseFloat(item.cft) || 0),
        0,
    );

    //Fix density calculation (use numbers, then format)
    const density =
        totalVolumeCbm > 0 ? (totalWeightKgs / totalVolumeCbm).toFixed(2) : "0.00";

    //Final formatted values
    const finalTotals = {
        totalPieces,
        totalWeightKgs: totalWeightKgs.toFixed(2),
        totalWeightLbs: totalWeightLbs.toFixed(2),
        totalVolumeCbm: totalVolumeCbm.toFixed(2),
        totalVolumeCft: totalVolumeCft.toFixed(2),
        density,
    };
    // {🚛🚛🚛🚛🚛 end  CARGO DETAIL calculations and handlers}

    // { start common clauses handlers}

    const syncClausesWithFormData = (apiClauses, formClauses) => {
        if (!apiClauses || apiClauses.length === 0) return apiClauses;

        // If no form clauses exist (new booking), return all as not applied
        if (!formClauses || formClauses.length === 0) {
            return apiClauses.map((item) => ({
                ...item,
                applied: false,
                id: null,
                bookingId: null,
            }));
        }

        // Merge API clauses with existing form data
        return apiClauses.map((apiClause) => {
            const existingClause = formClauses.find(
                (f) => f.clausesTypeDescriptionId === apiClause.ClauseTypeDescriptionID,
            );

            return {
                ...apiClause,
                applied: existingClause ? existingClause.isActive : false,
                id: existingClause ? existingClause.id : null,
                bookingId: existingClause ? existingClause.bookingId : null,
            };
        });
    };

    const getClauselistData = async (formClauses = []) => {
        try {
            const payload = {
                IPageNo: 1,
                IPageRecords: 1000,
                Type: 3,//type 3 for booking
            };

            const clauseData = await dispatch(getClauselist(payload));

            const transformedData = clauseData.map((item) => ({
                ClauseTypeDescriptionID: item.ClauseTypeDescriptionID,
                ClauseType: item.ClauseType,
                ClauseDescription: item.ClauseDescription,
                applied: false,
                id: null,
                bookingId: null,
            }));

            const syncedClauses = syncClausesWithFormData(
                transformedData,
                formClauses,
            );

            setClauses(syncedClauses);
            // console.log('Clauses loaded and synced:', syncedClauses);
        } catch (error) {
            // console.error('Error loading clauses:', error);
        }
    };

    const handleClauseChange = (clauseId, field, value) => {
        if (field === "applied") {
            setClauses((prevClauses) =>
                prevClauses.map((clause) => {
                    if (clause.ClauseTypeDescriptionID === clauseId) {
                        const newApplied =
                            typeof value === "boolean" ? value : !clause.applied;
                        const now = Date.now();

                        return {
                            ...clause,
                            applied: newApplied,
                            id: 0,
                            bookingId: newApplied
                                ? clause.bookingId || formData?.id || 0
                                : clause.bookingId,
                        };
                    }
                    return clause;
                }),
            );
        }
    };

    const [sameAsEmptyContainer, setSameAsEmptyContainer] = useState(false);

    const handleSameAsEmptyContainerChange = (e) => {
        const checked = e.target.checked;
        setSameAsEmptyContainer(checked);

        setFormData((prev) => ({
            ...prev,
            truckerContainerReturnTo: checked ? prev.truckerEmptyContainerPickup : "",
            truckerContainerReturnToId: checked
                ? prev.truckerEmptyContainerPickupId
                : "",
            truckerContainerReturnToAddress: checked
                ? prev.truckerEmptyContainerPickupAddress
                : "",
        }));
    };

    const prepareClausesForAPI = () => {
        const payloadMap = new Map();

        // 1️⃣ UI state: sirf applied = true wale
        clauses?.forEach((clause) => {
            if (clause.applied === true) {
                payloadMap.set(clause.ClauseTypeDescriptionID, {
                    id: clause.id || 0,
                    clausesTypeDescriptionId: clause.ClauseTypeDescriptionID,
                    isActive: true,
                });
            }
        });

        // 2️⃣ Old formData: jo pehle the, par ab UI me applied nahi hain
        originalFormClauses?.forEach((oldClause) => {
            const stillApplied = clauses?.some(
                (c) =>
                    c.ClauseTypeDescriptionID === oldClause.clausesTypeDescriptionId &&
                    c.applied === true,
            );

            if (!stillApplied) {
                payloadMap.set(oldClause.clausesTypeDescriptionId, {
                    id: oldClause.id,
                    clausesTypeDescriptionId: oldClause.clausesTypeDescriptionId,
                    isActive: false,
                });
            }
        });

        return Array.from(payloadMap.values());
    };

    const isChargeEmpty = (charge) => {
        return (
            !charge.descriptions &&
            !charge.currency &&
            charge.sellAmount === 0 &&
            charge.buyAmount === 0 &&
            charge.quantity === 0
        );
    };

    {
        /* end common clauses handlers */
    }

    const handleSubmit = async (e) => {
        debugger;
        if (e && e.preventDefault) e.preventDefault();
        // console.log('Form Data:', formData, 'Items:', items);
        try {
            dispatch(callLoader(1));
            var transhipmentPorts = [];
            var rates = [];

            const cleanedCargoItems = cargoItems.filter((item) => {
                return !(
                    item.piece === 0 &&
                    item.length === 0 &&
                    item.width === 0 &&
                    item.height === 0
                );
            });

            const payload = {
                ...formData,
                transhipmentPorts: transshipPorts,
                rates: charges,
                cargoDimensionDetails: cleanedCargoItems,
                clauses: prepareClausesForAPI(),
                // Include AR/AP charges in form_snapshot
                // formSnapshot: JSON.stringify({
                //     arCharges: arCharges,
                //     apCharges: apCharges
                // }),
                arCharges: arCharges,
                apCharges: apCharges,
            };

            console.log("Payload:", payload);
            // formvalidation setting here

            // const dynamicRules = buildValidationRules(charges);
            // console.log('Validation Rules:', dynamicRules);

            const filteredCharges = charges.filter(
                (charge) => !isChargeEmpty(charge),
            );

            const validationErrors = validateForm({
                data: formData,
                items: filteredCharges,
                rules: Validationbookingfrom,
            });

            setErrors(validationErrors);

            if (Object.keys(validationErrors).length > 0) {
                return;
            }

            const hasAnyDateError = Object.keys(dateErrors).length > 0;

            if (hasAnyDateError) {
                console.log("date error:", dateErrors);

                const errorMessages = Object.values(dateErrors);

                toast.error(
                    <div>
                        <strong>Please fix the following errors:</strong>
                        <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
                            {errorMessages.map((msg, idx) => (
                                <li key={idx}>{msg}</li>
                            ))}
                        </ul>
                    </div>,
                    { duration: 5000 },
                );

                // dispatch(showToast("Please correct the date fields", "error"));
                return;
            }
            //end  formvalidation setting here

            let response;

            if (bookingData && bookingData !== 0) {
                response = await updateBookingDetails(payload);
            } else {
                response = await addBookingDetails(payload);
                console.log("Add Booking Response:", response);

                // Extract values from result string
                const resultString = response?.result || "";

                const bookingIdMatch = resultString.match(/BookingId\s*:\s*(\d+)/);
                const fileNumberMatch = resultString.match(
                    /fileNumber\s*:\s*([A-Z0-9]+)/,
                );

                const bookingId = bookingIdMatch ? bookingIdMatch[1] : null;
                const fileNumber = fileNumberMatch ? fileNumberMatch[1] : null;

                console.log(
                    "Extracted Booking ID:",
                    bookingId,
                    "Extracted File Number:",
                    fileNumber,
                );
                // Assign bookingData
                bookingData = bookingId;

                // Update state
                setFormData((prev) => {
                    console.log(
                        "Parsed Booking ID:",
                        bookingId,
                        "File Number:",
                        fileNumber,
                    );
                    const parsedId = parseInt(bookingId, 10);

                    return {
                        ...prev,
                        id: isNaN(parsedId) ? 0 : parsedId,
                        modifiedBy:
                            `${authUser?.firstName ?? ""} ${authUser?.lastName ?? ""}`.trim(),
                        companyId: authUser?.companyId,
                        fileNumber: fileNumber,
                    };
                });
            }

            if (response?.statuscode === 200 || response?.statuscode === 201) {
                // toast.success("Booking details saved successfully");
                dispatch(
                    showToast("Booking details saved successfully", "success", true),
                );

                // Trigger notification for booking created/updated
                const isNewBooking = !bookingData || bookingData === 0;
                const fileNumber = formData?.fileNumber || payload?.fileNumber;
                const customerName = formData?.customerName || payload?.customerName;

                if (isNewBooking) {
                    notificationService.bookingCreated(fileNumber, customerName);
                } else {
                    notificationService.bookingStatusChanged(fileNumber, "Updated");
                }

                return {
                    success: true,
                    data: response.data,
                };
            } else {
                dispatch(
                    showToast(
                        response?.message || "Error Generated While Updating Booking",
                        "error",
                    ),
                );
            }

            return {
                success: false,
                status: response?.status,
            };
        } catch (error) {
            // console.error("Booking API Error:", error);
            // toast.error(
            //     error?.response?.data?.title ||
            //     error?.message ||
            //     "Something went wrong"
            // );
            dispatch(
                showToast(
                    error?.response?.data?.title ||
                    error?.message ||
                    "Something went wrong",
                    "error",
                ),
            );

            return {
                success: false,
                status: error?.response?.status,
                errors: error?.response?.data?.errors,
            };
        } finally {
            dispatch(callLoader(0));
        }
    };

    const AddListofVessel = async () => {
        try {
            dispatch(callLoader(1)); // 🔥 Loader ON
            const payloadVessel = {
                CarrierScac: formData?.carrierCode,
                originPortCode: formData?.portOfLoadingCode,
                destinationPortCode: formData?.portOfDischargeCode,
                searchDate: formatDate(formData?.etsAtOrigin),
            };

            const list = await dispatch(GetVesselSchedule(payloadVessel));

            console.log("Vessel List:", list); // check array

            setVesselList(list);
            setShowModal(true);
        } catch (error) {
            console.error("Error fetching vessel schedule:", error);
            setVesselList([]); // safety
        } finally {
            dispatch(callLoader(0)); // 🔥 Loader OFF (always run)
        }
    };

    const handleSelectVessel = (item) => {
        setFormData((prev) => ({
            ...prev,
            vessel: item.vesselName,
            voyage: item.voyageNumber,
            etsAtPol: item.originDepartureDate
                ? new Date(item.originDepartureDate)
                : null,
            etaAtPod: item.destinationArrivalDate
                ? new Date(item.destinationArrivalDate)
                : null,
            portCo: item.terminalCutoff ? new Date(item.terminalCutoff) : null,
            totalDuration: item.totalDuration,
        }));

        // modal close
        setShowModal(false);
    };

    const handledefaultSubmit = (e) => {
        e.preventDefault();
    };

    //     const [currentStep, setCurrentStep] = useState(2);

    // <VerticalStepper
    //   currentStep={currentStep}
    //   onStepClick={(step) => setCurrentStep(step)}
    // />;

    const _getPortCode = (strdata) => {
        if (!strdata) return "";
        const match = strdata.match(/\[(.*?)\]/);
        const code = match ? match[1] : "";
        console.log(code); // INBOM
        return code;
    };

    const SECTION_COLORS = {
        blue: { icon: "bg-blue-500" },
        teal: { icon: "bg-teal-500" },
        violet: { icon: "bg-violet-500" },
        cyan: { icon: "bg-cyan-500" },
        green: { icon: "bg-green-500" },
        indigo: { icon: "bg-indigo-500" },
        amber: { icon: "bg-amber-500" },
        orange: { icon: "bg-orange-500" },
        rose: { icon: "bg-rose-500" },
        dark: { icon: "bg-slate-700" },
        red: { icon: "bg-red-500" },
        pink: { icon: "bg-pink-500" },
    };

    const SectionHeader = ({
        icon: Icon,
        title,
        section,
        badge,
        action,
        color = "blue",
    }) => {
        const c = SECTION_COLORS[color] ?? SECTION_COLORS.blue;
        const isDark = color === "dark";

        return (
            <button
                onClick={() => toggleSection(section)}
                className="w-full flex items-center justify-between p-4 bg-gradient-to-r to-slate-100 dark:from-slate-800 dark:to-slate-700 cursor-pointer"
            >
                <div className="flex items-center gap-3">
                    <div className={`p-2 mx-2 rounded-lg shadow-md ${c.icon}`}>
                        <Icon className="w-4 h-4 text-white" />
                    </div>
                    <h2
                        className={`text-sm font-semibold ${isDark ? "text-slate-100" : "text-slate-900 dark:text-slate-200"}`}
                    >
                        {title}
                    </h2>
                    {badge && (
                        <span className="px-2 py-0.5 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400 text-xs font-medium rounded-full">
                            {badge}
                        </span>
                    )}
                </div>
                <div className="flex items-center gap-2">
                    {action}
                    <div
                        className={`p-1.5 rounded-md transition-colors ${expandedSections[section]
                            ? "bg-indigo-100 dark:bg-indigo-900/30"
                            : "bg-slate-200 dark:bg-slate-700"
                            }`}
                    >
                        {expandedSections[section] ? (
                            <ChevronUp className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
                        ) : (
                            <ChevronDown className="w-4 h-4 text-slate-500 dark:text-slate-400" />
                        )}
                    </div>
                </div>
            </button>
        );
    };
    // const SectionHeader = ({ icon: Icon, title, color, section, badge, action }) => (
    //     <button
    //         onClick={() => toggleSection(section)}
    //         className={`w-full flex items-center justify-between p-4 bg-[#0E7BCF] rounded-t-xl transition-all hover:opacity-90`}
    //     >
    //         <div className="flex items-center gap-3">
    //             <div className="bg-white/20 p-2 rounded-lg">
    //                 <Icon className="w-5 h-5 text-white" />
    //             </div>
    //             <h2 className="text-base font-semibold text-white">{title}</h2>
    //             {badge && (
    //                 <span className="px-2 py-0.5 bg-white/20 text-white text-xs font-medium rounded-full">
    //                     {badge}
    //                 </span>
    //             )}
    //         </div>
    //         <div className="flex items-center gap-2">
    //             {action}
    //             {expandedSections[section] ? (
    //                 <ChevronUp className="w-5 h-5 text-white/80" />
    //             ) : (
    //                 <ChevronDown className="w-5 h-5 text-white/80" />
    //             )}
    //         </div>
    //     </button>
    // );
    // bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden

    const handleCopyFields = (checkboxName, sourceKey, targets) => {
        const checked = !formData[checkboxName];
        handleInputChange({ target: { name: checkboxName, value: checked } });

        if (checked) {
            targets.forEach((t) => {
                handleInputChange({
                    target: { name: t.name, value: formData[t.valueKey] || "" },
                });
            });
        } else {
            targets.forEach((t) => {
                handleInputChange({
                    target: { name: t.name, value: t.clearValue ?? "" },
                });
            });
        }
    };
    const isEdit = Number(formData?.id) > 0;

    return (
        <div className="mx-auto p-2 sm:p-3 sticky top-0 bg-gradient-to-r">
            {/* Header - Responsive */}
            <PageHeader
                icon={
                    isEdit ? (
                        <PenLine className="w-5 h-5 text-white" />
                    ) : (
                        <Ship className="w-5 h-5 text-white" />
                    )
                }
                title="Booking Information"
                // badge={isEdit ? "Editing Booking" : "New Booking"}
                subtitle={
                    isEdit ? (
                        <>
                            {`File Reference `}
                            <span className="text-slate-700 font-semibold dark:text-slate-300">
                                {formData?.fileNumber}
                            </span>
                        </>
                    ) : (
                        ""
                    )
                }
                actions={[
                    // always visible
                    { label: "Cancel", icon: <X />, onClick: onBack, variant: "ghost" },

                    // edit-mode only
                    ...(isEdit
                        ? [
                            {
                                label: "Print",
                                icon: <Printer />,
                                onClick: () =>
                                    window.open(`/booking/print/${btoa(formData?.id)}`),
                                variant: "tertiary",
                            },
                            "|",
                            {
                                label: "Dock Receipt",
                                onClick: () =>
                                    navigate(`/dock-receipt/${formData?.id}`, {
                                        state: {
                                            bookingId: formData?.id,
                                            FILENUMBER: formData?.fileNumber,
                                            ourPlaceOfReceipt: formData?.ourPlaceOfReceipt,
                                            ourMoveType: formData?.ourMoveType,
                                            vessel: formData?.vessel,
                                            carrier: formData?.carrier,
                                            portOfLoading: formData?.portOfLoading,
                                            portOfDischarge: formData?.portOfDischarge,
                                            ourPlaceOfDelivery: formData?.ourPlaceOfDelivery,
                                            carrierBookingNumber: formData?.carrierBookingNumber,
                                            customerReference: formData?.customerReference,
                                        },
                                    }),
                                variant: "tertiary",
                            },
                            {
                                label: "HBL",
                                onClick: () =>
                                    navigate("/hbl", {
                                        state: {
                                            bookingId: formData?.id,
                                            FILENUMBER: formData?.fileNumber,
                                        },
                                    }),
                                variant: "tertiary",
                            },
                            {
                                label: "MBL",
                                onClick: () =>
                                    navigate("/mbl", {
                                        state: {
                                            bookingId: formData?.id,
                                            FILENUMBER: formData?.fileNumber,
                                        },
                                    }),
                                variant: "tertiary",
                            },
                            "|",
                            {
                                label: "Status Audit",
                                icon: <FileCheck2 />,
                                onClick: () =>
                                    navigate("/status-audit", {
                                        state: {
                                            bookingId: formData?.id,
                                            FILENUMBER: formData?.fileNumber,
                                            createdOn: formData?.createdOn,
                                            customerName: formData?.customerName,
                                            createdBy: formData?.createdBy,
                                            carrierBookingNumber: formData?.carrierBookingNumber,
                                        },
                                    }),
                                variant: "black",
                            },
                        ]
                        : []),

                    "|",

                ]}
                onSubmit={handleSubmit}
            />
            <div style={{ height: "var(--page-header-height)" }} />
            <form className="space-y-4" onSubmit={handledefaultSubmit}>
                {/* Booking Information && Customer Information */}
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                    {/* Customer Information */}
                    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                        <SectionHeader
                            icon={User}
                            title="Customer Information"
                            section="customer"
                        />

                        {expandedSections.customer && (
                            <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Customer / Shipper :
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetCustomerSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "customerName", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: { name: "customerId", value: d?.[0] },
                                                });
                                                _getAddresswithfulldetail("customerName", d?.[0]);
                                                _setAddress("customerAddress", d?.[0]);
                                            }}
                                            value={formData?.customerName}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "customerName", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "customerId", value: 0 },
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Contact Name:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-slate-200/30 dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.contactName || ""}
                                            onChange={handleInputChange}
                                            name="contactName"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Telephone:
                                        </label>
                                        <input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.telephone || ""}
                                            onChange={handleInputChange}
                                            name="telephone"
                                        // onBlur={(e) => handleBlurValidation(e, 'mobile')}
                                        />
                                        {errors.telephone && (
                                            <p className="text-red-500 text-xs">{errors.telephone}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Email:
                                        </label>
                                        <input
                                            type="email"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.email || ""}
                                            onChange={handleInputChange}
                                            onBlur={(e) => handleBlurValidation(e, "email")}
                                            name="email"
                                        />
                                        {errors.email && (
                                            <p className="text-red-500 text-xs">{errors.email}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 gap-4 mb-4">
                                    <Textarea
                                        className="mt-2  bg-white dark:bg-slate-800"
                                        rows="4"
                                        value={formData?.customerAddress || ""}
                                        onChange={handleInputChange}
                                        name="customerAddress"
                                    />
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Sales Person : <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="salesPersonId"
                                            value={formData?.salesPersonId}
                                            onChange={(e) => {
                                                const selectedOption = e.target.selectedOptions[0];
                                                const id = e.target.value;
                                                const name = selectedOption.dataset.name;

                                                handleInputChange({
                                                    target: { name: "salesPersonId", value: id },
                                                });
                                                handleInputChange({
                                                    target: { name: "salesPersonName", value: name },
                                                });
                                            }}
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        >
                                            <option value="">Select</option>
                                            {salesPersonList?.map((v) => (
                                                <option
                                                    key={v.salesPersonId}
                                                    value={v.salesPersonId}
                                                    data-name={v.salesPerson}
                                                >
                                                    {v.salesPerson}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Booking Information */}
                    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                        <SectionHeader
                            icon={FileCheck}
                            title="Booking Information"
                            color="bg-blue-500"
                            section="booking"
                        />

                        {expandedSections.booking && (
                            <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                                <div className="flex flex-row gap-6 col-span-2 py-4">
                                    <label
                                        className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md border cursor-pointer transition-all duration-200
                    ${formData?.preBooking
                                                ? "bg-blue-50 border-blue-400 dark:bg-blue-900/30 dark:border-blue-500"
                                                : "border-gray-300 dark:bg-slate-800 dark:border-slate-700 hover:bg-gray-200 dark:hover:bg-slate-700"
                                            }`}
                                    >
                                        <input
                                            type="checkbox"
                                            name="preBooking"
                                            checked={formData?.preBooking}
                                            onChange={handleInputChange}
                                            className="accent-[#0072FF] w-3 h-3"
                                        />

                                        <span
                                            className={`text-xs font-medium ${formData?.preBooking
                                                ? "text-blue-700 dark:text-blue-400"
                                                : "text-slate-800 dark:text-slate-300"
                                                }`}
                                        >
                                            PRE BOOKING
                                        </span>
                                    </label>
                                    <label className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border cursor-pointer transition-all duration-200 bg-blue-700 text-white hover:bg-slate-700 dark:bg-slate-600 dark:text-slate-900 dark:hover:bg-slate-500">
                                        <input
                                            type="checkbox"
                                            name="sendBookingCargoSmart"
                                            checked={formData?.sendBookingCargoSmart}
                                            onChange={handleInputChange}
                                            className="accent-[#0072FF] w-3 h-3"
                                        />

                                        <span className="text-xs font-medium dark:text-slate-100 ">
                                            SEND TO CARGO SMART
                                        </span>
                                    </label>
                                    <label className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border cursor-pointer transition-all duration-200 bg-slate-900 text-white hover:bg-slate-700 dark:bg-slate-600 dark:text-slate-900 dark:hover:bg-slate-500">
                                        <input
                                            type="checkbox"
                                            name="sendBookingIntra"
                                            checked={formData?.sendBookingInttra}
                                            onChange={handleInputChange}
                                            className="accent-[#0072FF] w-3 h-3"
                                        />

                                        <span className="text-xs font-medium  dark:text-slate-100">
                                            SEND TO INTRA
                                        </span>
                                    </label>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            BL Mode:<span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.blModeId || ""}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                handleInputChange({
                                                    target: {
                                                        name: "blMode",
                                                        value:
                                                            e.target.options[e.target.selectedIndex].text,
                                                    },
                                                });
                                            }}
                                            name="blModeId"
                                        >
                                            {" "}
                                            <option value="">Select BL Mode</option>
                                            <option value={1}>SINGLE BL</option>
                                            <option value={2}>MULTIPLE BL's</option>
                                            <option value={3}>DIRECT MBL</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Office Type:<span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.officeTypeId || ""}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                handleInputChange({
                                                    target: {
                                                        name: "officeType",
                                                        value:
                                                            e.target.options[e.target.selectedIndex].text,
                                                    },
                                                });
                                            }}
                                            name="officeTypeId"
                                        >
                                            {" "}
                                            <option value="">Select Office</option>
                                            <option value={1}>NEW YORK</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            File Number:<span className="text-red-500">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-gray-300 dark:bg-slate-600 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.fileNumber}
                                            onChange={handleInputChange}
                                            name="fileNumber"
                                            readOnly
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Customer Ref. #:
                                        </label>
                                        <input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.customerReference || ""}
                                            onChange={handleInputChange}
                                            name="customerReference"
                                        />
                                    </div>
                                    {/* <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                                Shipment Group:
                                            </label>
                                            <select className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                value={formData?.shippingType || ''}
                                                onChange={handleInputChange}
                                                name="shippingType"
                                            >
                                                <option>select</option>
                                                <option value={1}>shipez</option>
                                            </select>
                                        </div> */}
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Carrier Booking Number:
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.carrierBookingNumber || ""}
                                            onChange={handleInputChange}
                                            name="carrierBookingNumber"
                                        />
                                    </div>

                                    {/* <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">Shipment #:</label>
                                            <Input className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]" type="text" value={formData?.shipment || ''} onChange={handleInputChange} name="shipment" />
                                        </div> */}
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Carrier BL Number:
                                        </label>
                                        <Input
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            type="text"
                                            value={formData?.carrierB || ""}
                                            onChange={handleInputChange}
                                            name="carrierB"
                                        />
                                    </div>
                                    {/* <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">Invoice:</label>
                                            <Input className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]" type="text" value={formData?.invoice || ''} onChange={handleInputChange} name="invoice" />
                                        </div> */}

                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Booking Type:
                                        </label>
                                        <select
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.bookingTypeId || ""}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                handleInputChange({
                                                    target: {
                                                        name: "bookingType",
                                                        value:
                                                            e.target.options[e.target.selectedIndex].text,
                                                    },
                                                });
                                            }}
                                            name="bookingTypeId"
                                        >
                                            {" "}
                                            <option value="">Select Booking Type</option>
                                            <option selected="selected" value={1}>
                                                Freight Forwarder
                                            </option>
                                            <option value={2}>NVO</option>
                                            <option value={3}>Document Only</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            File Manager:
                                        </label>
                                        <select
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.operatorId || ""}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                handleInputChange({
                                                    target: {
                                                        name: "operatorName",
                                                        value:
                                                            e.target.options[e.target.selectedIndex].text,
                                                    },
                                                });
                                            }}
                                            name="operatorId"
                                        >
                                            {" "}
                                            <option value="">SELECT Manager</option>
                                            {fileManagerList.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.filemanager}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Co-loader Ref No:
                                        </label>
                                        <Input
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            type="text"
                                            value={formData?.coLoaderRefNo || ""}
                                            onChange={handleInputChange}
                                            name="coLoaderRefNo"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Inco Term:
                                        </label>
                                        <select
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF] "
                                            value={formData?.incoTermId || ""}
                                            name="incoTermId"
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                handleInputChange({
                                                    target: {
                                                        name: "incoTerm",
                                                        value:
                                                            e.target.options[e.target.selectedIndex].text,
                                                    },
                                                });
                                            }}
                                        >
                                            <option value="">SELECT</option>
                                            {incoTermsList?.map((term, key) => (
                                                <option key={key} value={term?.id}>
                                                    {term?.incoterm}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Rate Quote Number:
                                        </label>

                                        <div className="relative">
                                            <Input
                                                className="w-full pr-10 px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="text"
                                                value={formData?.rqNumber || ""}
                                                onChange={handleInputChange}
                                                name="rqNumber"
                                            />

                                            {/* 👁 View Icon */}
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (!formData?.rateQuoteId) return;
                                                    window.open(
                                                        `/rate-quote/edit/${formData.rateQuoteId}`,
                                                        "_blank",
                                                    );
                                                }}
                                                className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500 hover:text-[#0072FF] transition"
                                                title="View Rate Quote"
                                            >
                                                <Eye size={18} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-2">
                                    <label className="block text-xs font-semibold text-slate-500 mb-3 uppercase tracking-wider">
                                        Shipping Type:
                                    </label>

                                    <div className="inline-flex rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-800 p-1 gap-1">
                                        {/* FCL */}
                                        <label
                                            className={`
                        flex items-center gap-2 px-4 py-2 rounded-lg cursor-pointer transition-all select-none
                        ${formData?.shippingType === "FCL"
                                                    ? "bg-cyan-500 shadow-sm"
                                                    : "hover:bg-slate-200 dark:hover:bg-slate-700"
                                                }
                      `}
                                        >
                                            <input
                                                type="radio"
                                                name="shippingType"
                                                value="FCL"
                                                className="sr-only"
                                                checked={formData?.shippingType === "FCL"}
                                                onChange={handleInputChange}
                                            />
                                            <Building2
                                                className={`w-4 h-4 ${formData?.shippingType === "FCL"
                                                    ? "text-white"
                                                    : "text-slate-400 dark:text-slate-500"
                                                    }`}
                                            />
                                            <span
                                                className={`text-sm font-semibold ${formData?.shippingType === "FCL"
                                                    ? "text-white"
                                                    : "text-slate-500 dark:text-slate-400"
                                                    }`}
                                            >
                                                FCL
                                            </span>
                                            {formData?.shippingType === "FCL" && (
                                                <span className="text-[10px] text-cyan-100 hidden sm:inline">
                                                    Full Container
                                                </span>
                                            )}
                                        </label>

                                        {/* LCL */}
                                        <label
                                            className={`
    flex items-center gap-2 px-4 py-2 rounded-lg cursor-pointer transition-all select-none
    ${formData?.shippingType === "LCL"
                                                    ? "bg-amber-500 shadow-sm"
                                                    : "hover:bg-slate-200 dark:hover:bg-slate-700"
                                                }
  `}
                                        >
                                            <input
                                                type="radio"
                                                name="shippingType"
                                                value="LCL"
                                                className="sr-only"
                                                checked={formData?.shippingType === "LCL"}
                                                onChange={handleInputChange}
                                            />
                                            <Package
                                                className={`w-4 h-4 ${formData?.shippingType === "LCL"
                                                    ? "text-white"
                                                    : "text-slate-400 dark:text-slate-500"
                                                    }`}
                                            />
                                            <span
                                                className={`text-sm font-semibold ${formData?.shippingType === "LCL"
                                                    ? "text-white"
                                                    : "text-slate-500 dark:text-slate-400"
                                                    }`}
                                            >
                                                LCL
                                            </span>
                                            {formData?.shippingType === "LCL" && (
                                                <span className="text-[10px] text-amber-100 hidden sm:inline">
                                                    Less Container
                                                </span>
                                            )}
                                        </label>

                                        {/* RO-RO */}
                                        <label
                                            className={`
    flex items-center gap-2 px-4 py-2 rounded-lg cursor-pointer transition-all select-none
    ${formData?.shippingType === "RO-RO"
                                                    ? "bg-purple-500 shadow-sm"
                                                    : "hover:bg-slate-200 dark:hover:bg-slate-700"
                                                }
  `}
                                        >
                                            <input
                                                type="radio"
                                                name="shippingType"
                                                value="RO-RO"
                                                className="sr-only"
                                                checked={formData?.shippingType === "RO-RO"}
                                                onChange={handleInputChange}
                                            />
                                            <Truck
                                                className={`w-4 h-4 ${formData?.shippingType === "RO-RO"
                                                    ? "text-white"
                                                    : "text-slate-400 dark:text-slate-500"
                                                    }`}
                                            />
                                            <span
                                                className={`text-sm font-semibold ${formData?.shippingType === "RO-RO"
                                                    ? "text-white"
                                                    : "text-slate-500 dark:text-slate-400"
                                                    }`}
                                            >
                                                RO-RO
                                            </span>
                                            {formData?.shippingType === "RO-RO" && (
                                                <span className="text-[10px] text-purple-100 hidden sm:inline">
                                                    Roll-on/Roll-off
                                                </span>
                                            )}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* Booking Request Number && Shipper & Consignee Information */}
                <div className="grid grid-cols-1 xl:grid-cols-1 gap-6">
                    {/* Shipper & Consignee Information*/}
                    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                        <SectionHeader
                            icon={FileCheck}
                            title="Shipper & Consignee Information"
                            color="bg-cyan-500"
                            section="blDirect"
                        />

                        {expandedSections.blDirect && (
                            <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div className="p-4 ">
                                        <div className="flex items-center justify-between mb-1.5">
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                                Shipper:
                                            </label>
                                            <div className="flex items-center gap-2 mr-24">
                                                <input
                                                    className="h-4 w-4 text-blue-600 rounded border-slate-300 focus:ring-blue-500"
                                                    type="checkbox"
                                                    name="shipperSameAsCustomer"
                                                    checked={formData?.shipperSameAsCustomer}
                                                    onChange={() =>
                                                        handleCopyFields(
                                                            "shipperSameAsCustomer",
                                                            "customerName",
                                                            [
                                                                { name: "shipper", valueKey: "customerName" },
                                                                {
                                                                    name: "shipperId",
                                                                    valueKey: "customerId",
                                                                    clearValue: 0,
                                                                },
                                                                {
                                                                    name: "shipperAddress",
                                                                    valueKey: "customerAddress",
                                                                },
                                                            ],
                                                        )
                                                    }
                                                />
                                                <label className="text-xs text-slate-600 dark:text-slate-400">
                                                    Same as Customer
                                                </label>
                                            </div>
                                        </div>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetConsigneeSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "shipper", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: { name: "shipperId", value: d?.[0] },
                                                });
                                                _setAddress("shipperAddress", d?.[0]);
                                            }}
                                            value={formData?.shipper || ""}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "shipper", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "shipperId", value: 0 },
                                                    });
                                                }
                                            }}
                                        />
                                        <Textarea
                                            className="mt-2  bg-white dark:bg-slate-800"
                                            rows="4"
                                            value={formData?.shipperAddress || ""}
                                            onChange={handleInputChange}
                                            name="shipperAddress"
                                        />
                                    </div>
                                    <div className="p-4">
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Consignee:<span className="text-red-500">*</span>
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetConsigneeSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "consignee", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: { name: "consigneeId", value: d?.[0] },
                                                });
                                                _setAddress("consigneeAddress", d?.[0]);
                                            }}
                                            value={formData?.consignee || ""}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "consignee", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "consigneeId", value: 0 },
                                                    });
                                                }
                                            }}
                                        />
                                        <Textarea
                                            className="mt-2  bg-white dark:bg-slate-800"
                                            rows="4"
                                            value={formData?.consigneeAddress || ""}
                                            onChange={handleInputChange}
                                            name="consigneeAddress"
                                        />
                                    </div>
                                    <div className="p-4 ">
                                        <div className="flex items-center justify-between mb-1.5">
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                                Notify:
                                            </label>
                                            <div className="flex items-center gap-2 mr-24">
                                                <input
                                                    type="checkbox"
                                                    name="notifySameAsConsignee"
                                                    checked={formData?.notifySameAsConsignee}
                                                    onChange={() =>
                                                        handleCopyFields(
                                                            "notifySameAsConsignee",
                                                            "consignee",
                                                            [
                                                                { name: "notify", valueKey: "consignee" },
                                                                {
                                                                    name: "notifyId",
                                                                    valueKey: "consigneeId",
                                                                    clearValue: 0,
                                                                },
                                                                {
                                                                    name: "notifyAddress",
                                                                    valueKey: "consigneeAddress",
                                                                },
                                                            ],
                                                        )
                                                    }
                                                />

                                                <label className="text-xs text-slate-600 dark:text-slate-400">
                                                    Same as Consignee
                                                </label>
                                            </div>
                                        </div>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetConsigneeSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "notify", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: { name: "notifyId", value: d?.[0] },
                                                });
                                                _setAddress("notifyAddress", d?.[0]);
                                            }}
                                            value={formData?.notify || ""}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "notify", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "notifyId", value: 0 },
                                                    });
                                                }
                                            }}
                                        />
                                        <Textarea
                                            className="mt-2  bg-white dark:bg-slate-800"
                                            rows="4"
                                            value={formData?.notifyAddress || ""}
                                            onChange={handleInputChange}
                                            name="notifyAddress"
                                        />
                                    </div>
                                    <div className="p-4 ">
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Also Notify:
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetConsigneeSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "alsoNotify", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: { name: "alsoNotifyId", value: d?.[0] },
                                                });
                                                _setAddress("alsoNotifyAddress", d?.[0]);
                                            }}
                                            value={formData?.alsoNotify || ""}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "alsoNotify", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "alsoNotifyId", value: 0 },
                                                    });
                                                }
                                            }}
                                        />
                                        <Textarea
                                            className="mt-2  bg-white dark:bg-slate-800"
                                            rows="4"
                                            value={formData?.alsoNotifyAddress || ""}
                                            onChange={handleInputChange}
                                            name="alsoNotifyAddress"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* Routing Information */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={Route}
                        title="Routing Information"
                        color="bg-purple-500"
                        section="routing"
                    />

                    {expandedSections.routing && (
                        <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                            {/* Visual Route Display */}
                            <div className="mb-6 px-6 py-4 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-700 shadow-sm">
                                <div className="flex items-center gap-4">
                                    <div className="flex items-center gap-3 min-w-0">
                                        <div className="w-11 h-11 flex-shrink-0 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center shadow-md shadow-blue-400/30">
                                            <MapPin className="w-5 h-5 text-white" />
                                        </div>
                                        <div className="min-w-0">
                                            <p className="text-[10px] font-semibold tracking-widest text-slate-400 dark:text-slate-500 uppercase">
                                                Origin
                                            </p>
                                            <p className="flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
                                                <InlineCountryFlag code={formData?.portOfLoadingCode} />
                                                <span>{formData?.portOfLoading || "Port of Loading"}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex-1 flex items-center relative mx-2 h-8">
                                        <div className="w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" />
                                        <div className="flex-1 h-0.5 self-center bg-gradient-to-r from-blue-400 via-cyan-400 to-teal-400 relative">
                                            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                                                <div className="w-9 h-9 rounded-full bg-white dark:bg-slate-900 border-2 border-slate-200 flex items-center justify-center shadow-md shadow-cyan-300/20">
                                                    <Ship className="w-4 h-4 text-cyan-500" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-1.5 h-1.5 rounded-full bg-teal-400 flex-shrink-0" />
                                    </div>
                                    <div className="flex items-center gap-3 min-w-0 flex-row-reverse">
                                        <div className="w-11 h-11 flex-shrink-0 rounded-full bg-gradient-to-br from-teal-500 to-emerald-500 flex items-center justify-center shadow-md shadow-teal-400/30">
                                            <MapPin className="w-5 h-5 text-white" />
                                        </div>
                                        <div className="min-w-0 text-right">
                                            <p className="text-[10px] font-semibold tracking-widest text-slate-400 dark:text-slate-500 uppercase">
                                                Destination
                                            </p>
                                            <p className="flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
                                                <InlineCountryFlag
                                                    code={formData?.portOfDischargeCode}
                                                />
                                                <span>
                                                    {formData?.portOfDischarge || "Port of Discharge"}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 3-Column Grid */}
                            <div className="grid grid-cols-3 gap-6 items-start">
                                {/* ── Column 1: Location Fields ── */}
                                <div className="grid grid-cols-1 gap-4">
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Place of Receipt
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "ourPlaceOfReceipt", value: d?.[1] },
                                                });
                                            }}
                                            value={formData?.ourPlaceOfReceipt}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "ourPlaceOfReceipt", value: "" },
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Loading Location
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: {
                                                        name: "carrierPlaceOfReceipt",
                                                        value: d?.[1],
                                                    },
                                                });
                                            }}
                                            value={formData?.carrierPlaceOfReceipt}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: {
                                                            name: "carrierPlaceOfReceipt",
                                                            value: "",
                                                        },
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Port of Loading:<span className="text-red-500">*</span>
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "portOfLoading", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: {
                                                        name: "portOfLoadingCode",
                                                        value: _getPortCode(d?.[1]),
                                                    },
                                                });
                                            }}
                                            value={formData?.portOfLoading}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "portOfLoading", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "portOfLoadingCode", value: "" },
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Port of Discharge:<span className="text-red-500">*</span>
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "portOfDischarge", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: {
                                                        name: "portOfDischargeCode",
                                                        value: _getPortCode(d?.[1]),
                                                    },
                                                });
                                            }}
                                            value={formData?.portOfDischarge}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "portOfDischarge", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "portOfDischargeCode", value: "" },
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Carrier Place of Delivery
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: {
                                                        name: "carrierPlaceOfDelivery",
                                                        value: d?.[1],
                                                    },
                                                });
                                            }}
                                            value={formData?.carrierPlaceOfDelivery}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: {
                                                            name: "carrierPlaceOfDelivery",
                                                            value: "",
                                                        },
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Our Place of Delivery
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "ourPlaceOfDelivery", value: d?.[1] },
                                                });
                                            }}
                                            value={formData?.ourPlaceOfDelivery}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "ourPlaceOfDelivery", value: "" },
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Country of Destination
                                        </label>
                                        <select
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.countryOfDestination || ""}
                                            onChange={handleInputChange}
                                            name="countryOfDestination"
                                        >
                                            <option>Select Country</option>
                                            {countryList?.map((country, key) => (
                                                <option key={key} value={country.incoterm}>
                                                    {country.incoterm}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label
                                            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md border cursor-pointer transition-all duration-200
              ${formData?.hodeCarrier
                                                    ? "bg-blue-50 border-blue-400 dark:bg-blue-900/30 dark:border-blue-500"
                                                    : "border-gray-300 dark:bg-slate-800 dark:border-slate-700 hover:bg-gray-200 dark:hover:bg-slate-700"
                                                }`}
                                        >
                                            <input
                                                type="checkbox"
                                                name="hodeCarrier"
                                                checked={formData?.hodeCarrier}
                                                onChange={handleInputChange}
                                                className="accent-[#0072FF] w-3 h-3"
                                            />
                                            <span
                                                className={`text-xs font-medium ${formData?.hodeCarrier ? "text-blue-700 dark:text-blue-400" : "text-slate-800 dark:text-slate-300"}`}
                                            >
                                                HIDE CARRIER
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                {/* ── Column 2: Move Type + First 6 Dates ── */}
                                <div className="grid grid-cols-1 gap-4">
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Move Type: <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="carrierMoveType"
                                            value={formData?.carrierMoveType || ""}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        >
                                            <option value="">SELECT TYPE</option>
                                            {moveTypeList.map((item, index) => (
                                                <option key={index} value={item.moveType}>
                                                    {item.moveType}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="hidden">
                                        <label className="text-sm text-slate-600">Move type</label>
                                        <select
                                            name="ourMoveType"
                                            value={formData?.ourMoveType || ""}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        >
                                            <option value="">SELECT TYPE</option>
                                            {moveTypeList.map((item, index) => (
                                                <option key={index} value={item.moveType}>
                                                    {item.moveType}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            OUR Doc C/O
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="OUR Doc C/O"
                                            name="ourDocCo"
                                            value={formData?.ourDocCo}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">VGM C/O</label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="VGM C/O"
                                            name="vgmCo"
                                            value={formData?.vgmCo}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">SL Doc C/O</label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="SL Doc C/O"
                                            name="sslDocCo"
                                            value={formData?.sslDocCo}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Earliest Pickup Date
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="Earliest Pickup Date"
                                            name="earliestPickupDate"
                                            value={formData?.earliestPickupDate}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Earliest Recvd Date :
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="Earliest Recvd Date"
                                            name="earliestRecvdDate"
                                            value={formData?.earliestRecvdDate}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">Auto C/O</label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="Auto C/O"
                                            name="autoCo"
                                            value={formData?.autoCo}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* ── Column 3: Remaining Dates ── */}
                                <div className="grid grid-cols-1 gap-4">
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Title cut off
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="Title cut off"
                                            name="titleCutOff"
                                            value={formData?.titleCutOff}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Inland/Rail C/O
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="Inland/Rail C/O"
                                            name="inlandEailCo"
                                            value={formData?.inlandEailCo}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            Port C/O:<span className="text-red-500">*</span>
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="Port C/O"
                                            name="portCo"
                                            value={formData?.portCo}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            ETS at Origin
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="ETS at Origin"
                                            name="etsAtOrigin"
                                            value={formData?.etsAtOrigin}
                                            onChange={handleDateChange}
                                            required
                                        />
                                        {dateErrors?.etsAtOrigin && (
                                            <p className="text-red-500 text-xs mt-1">
                                                {dateErrors?.etsAtOrigin}
                                            </p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            ETS at POL:<span className="text-red-500">*</span>
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="ETS at POL"
                                            name="etsAtPol"
                                            value={formData?.etsAtPol}
                                            onChange={handleDateChange}
                                            required
                                        />
                                        {dateErrors?.etsAtPol && (
                                            <p className="text-red-500 text-xs mt-1">
                                                {dateErrors?.etsAtPol}
                                            </p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            ETA at POD:<span className="text-red-500">*</span>
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="ETA at POD"
                                            name="etaAtPod"
                                            value={formData?.etaAtPod}
                                            onChange={handleDateChange}
                                            required
                                        />
                                        {dateErrors?.etaAtPod && (
                                            <p className="text-red-500 text-xs mt-1">
                                                {dateErrors?.etaAtPod}
                                            </p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="text-sm text-slate-600">
                                            ETA at Destination
                                        </label>
                                        <DateTimeInputwithcal
                                            onError={handleDateError}
                                            label="ETA at Destination"
                                            name="etaAtDestination"
                                            value={formData?.etaAtDestination}
                                            onChange={handleDateChange}
                                            required
                                        />
                                        {dateErrors?.etaAtDestination && (
                                            <p className="text-red-500 text-xs mt-1">
                                                {dateErrors?.etaAtDestination}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Vessel Schedule */}
                            <div className="mt-6">
                                <div className="flex items-center gap-2 mb-4">
                                    <button
                                        type="button"
                                        onClick={AddListofVessel}
                                        className="flex items-center gap-2 p-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-sm transition-all duration-200"
                                    >
                                        <Calendar className="w-4 h-4" />
                                        <span className="text-sm font-small">Vessel Schedule</span>
                                    </button>
                                    <p className="text-xs text-slate-500 dark:text-slate-400">
                                        Vessel & Carrier Information
                                    </p>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                    <div className="flex flex-col gap-1">
                                        <label className="text-xs font-medium text-slate-900 dark:text-slate-300">
                                            Carrier <span className="text-red-500">*</span>
                                        </label>
                                        <SearchBar
                                            searchAPI="v1/AutoSuggestion/GetCarrierSuggestion?Prefix="
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "carrier", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: {
                                                        name: "carrierCode",
                                                        value: String(d?.[2] ?? ""),
                                                    },
                                                });
                                            }}
                                            value={formData?.carrier || ""}
                                            placeholder="Select carrier"
                                            className="bg-white dark:bg-slate-900 border border-slate-700 rounded-lg text-sm text-white"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <label className="text-xs font-medium text-slate-900 dark:text-slate-300">
                                            Carrier Contract Number
                                        </label>
                                        <Input
                                            name="carrierContractNumber"
                                            value={formData?.carrierContractNumber || ""}
                                            onChange={handleInputChange}
                                            placeholder="Contract number"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <label className="text-xs font-medium text-slate-900 dark:text-slate-300">
                                            Vessel
                                        </label>
                                        <SearchBar
                                            searchAPI="v1/AutoSuggestion/GetVesselList?Prefix="
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "vessel", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: {
                                                        name: "vesselCode",
                                                        value: String(d?.[0] ?? ""),
                                                    },
                                                });
                                            }}
                                            value={formData?.vessel || ""}
                                            placeholder="Select vessel"
                                            className="bg-white dark:bg-slate-900 border border-slate-700 rounded-lg text-sm text-white"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <label className="text-xs font-medium text-slate-900 dark:text-slate-300">
                                            Voyage
                                        </label>
                                        <Input
                                            name="voyage"
                                            value={formData?.voyage || ""}
                                            onChange={handleInputChange}
                                            placeholder="Voyage number"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Transshipment Ports Section */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={Ship}
                        title="Transshipment Ports"
                        color="bg-cyan-600"
                        section="transship"
                    />

                    {expandedSections.transship && (
                        <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                            <table className="w-full text-sm">
                                <thead>
                                    <tr className="border-b border-slate-200 dark:border-slate-800 bg-slate-100 dark:bg-slate-800/50">
                                        <th className="px-2 py-2 text-left text-sm font-semibold text-slate-600 dark:text-slate-400">
                                            SNO
                                        </th>
                                        <th className="px-2 py-2 text-left text-sm font-semibold text-slate-600 dark:text-slate-400">
                                            PORT/CITY
                                        </th>
                                        <th className="px-2 py-2 text-left text-sm font-semibold text-slate-600 dark:text-slate-400">
                                            ETA
                                        </th>
                                        <th className="px-2 py-2 text-left text-sm font-semibold text-slate-600 dark:text-slate-400">
                                            VESSEL
                                        </th>
                                        <th className="px-2 py-2 text-left text-sm font-semibold text-slate-600 dark:text-slate-400">
                                            ETD
                                        </th>
                                        <th className="px-2 py-2 text-left text-sm font-semibold text-slate-600 dark:text-slate-400">
                                            VOYAGE
                                        </th>
                                        <th className="px-2 py-2 text-left text-sm font-semibold text-slate-600 dark:text-slate-400"></th>
                                    </tr>
                                </thead>

                                <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                                    {transshipPorts.filter((p) => p?.isDeleted === false)
                                        .length === 0 ? (
                                        /* ── Empty state ── */
                                        <tr>
                                            <td colSpan="7" className="px-4 py-8 text-center">
                                                <div className="flex flex-col items-center gap-2">
                                                    <Ship className="w-8 h-8 text-slate-300 dark:text-slate-600" />
                                                    <p className="text-sm font-medium text-slate-400 dark:text-slate-500">
                                                        No transshipment ports added yet
                                                    </p>
                                                    <p className="text-xs text-slate-300 dark:text-slate-600">
                                                        Click the button below to add a transshipment port
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        transshipPorts.map(
                                            (port, index) =>
                                                port?.isDeleted === false && (
                                                    <tr
                                                        key={index}
                                                        className="hover:bg-slate-50 dark:hover:bg-slate-800/30"
                                                    >
                                                        <td className="px-2 py-2 text-slate-600 dark:text-slate-400">
                                                            {index + 1}
                                                        </td>
                                                        <td className="px-2 py-2 text-slate-600 dark:text-slate-400">
                                                            <SearchBar
                                                                searchAPI="v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                                                                selectReacord={(d) =>
                                                                    handleTranshipPortChange(
                                                                        index,
                                                                        "transPortCity",
                                                                        d?.[1] || "",
                                                                    )
                                                                }
                                                                value={port.transPortCity}
                                                                onchange={(val) => {
                                                                    if (!val)
                                                                        handleTranshipPortChange(
                                                                            index,
                                                                            "transPortCity",
                                                                            "",
                                                                        );
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="px-2 py-2 text-slate-600 dark:text-slate-400">
                                                            <DateInputwithcal
                                                                label="ETA"
                                                                name="transEta"
                                                                value={port.transEta}
                                                                onChange={(name, value) =>
                                                                    handleTranshipPortChange(
                                                                        index,
                                                                        "transEta",
                                                                        value,
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td className="px-2 py-2 text-slate-600 dark:text-slate-400">
                                                            <SearchBar
                                                                searchAPI="v1/AutoSuggestion/GetVesselList?Prefix="
                                                                selectReacord={(d) =>
                                                                    handleTranshipPortChange(
                                                                        index,
                                                                        "transVessel",
                                                                        d?.[1] || "",
                                                                    )
                                                                }
                                                                value={port.transVessel}
                                                                onchange={(val) => {
                                                                    if (!val)
                                                                        handleTranshipPortChange(
                                                                            index,
                                                                            "transVessel",
                                                                            "",
                                                                        );
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="px-2 py-2 text-slate-600 dark:text-slate-400">
                                                            <DateInputwithcal
                                                                label="ETD"
                                                                name="transEtd"
                                                                value={port.transEtd}
                                                                onChange={(name, value) =>
                                                                    handleTranshipPortChange(
                                                                        index,
                                                                        "transEtd",
                                                                        value,
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td className="px-2 py-2 text-slate-600 dark:text-slate-400">
                                                            <Input
                                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                                value={port.transVoyage}
                                                                onChange={(e) =>
                                                                    handleTranshipPortChange(
                                                                        index,
                                                                        "transVoyage",
                                                                        e.target.value,
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td className="px-2 py-2 text-slate-600 dark:text-slate-400">
                                                            <button
                                                                type="button"
                                                                className="p-2 rounded-lg text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/30 transition"
                                                                title="Delete"
                                                                onClick={() =>
                                                                    handleTranshipPortChange(
                                                                        index,
                                                                        "isDeleted",
                                                                        true,
                                                                    )
                                                                }
                                                            >
                                                                <Trash2 className="w-4 h-4" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ),
                                        )
                                    )}
                                </tbody>

                                <tfoot className="bg-slate-50 dark:bg-slate-800/60">
                                    <tr>
                                        <td colSpan="7" className="px-3 py-3">
                                            <button
                                                type="button"
                                                onClick={addTransshipPort}
                                                className="flex items-center gap-2 p-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-sm transition-all duration-200"
                                            >
                                                <Plus className="w-4 h-4" />
                                                <span className="text-sm font-small">
                                                    Add Transshipment Port
                                                </span>
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    )}
                </div>

                {/* Commodity & Container Information*/}
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                    {/* Commodity  */}
                    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200 ">
                        <SectionHeader
                            icon={Package}
                            title="Commodity Information"
                            color="bg-orange-500"
                            section="commodity"
                        />

                        {expandedSections.commodity && (
                            <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Commodity Group:<span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.commodityGroupId || ""}
                                            onChange={(e) => {
                                                handleInputChange({
                                                    target: {
                                                        name: "commodityGroupId",
                                                        value: e.target.value,
                                                    },
                                                });
                                                handleInputChange({
                                                    target: {
                                                        name: "commodityGroup",
                                                        value:
                                                            e.target.options[e.target.selectedIndex].text,
                                                    },
                                                });
                                            }}
                                        >
                                            <option>Select</option>
                                            {commodityGroupList?.map((group, key) => (
                                                <option key={key} value={group.moveTypeId}>
                                                    {group.moveType}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Commodity:
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetCommoditySuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "commodity", value: d?.[1] },
                                                });
                                            }}
                                            value={formData?.commodity || ""}
                                            onchange={(value) => {
                                                handleInputChange({
                                                    target: { name: "commodity", value },
                                                });
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            HSCodes / Sch B#:
                                        </label>
                                        <SearchBar
                                            searchAPI={"v1/AutoSuggestion/GetHtsusCode?Prefix="}
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "hsCodes", value: d?.[1] },
                                                });
                                            }}
                                            value={formData?.hsCodes || ""}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "hsCodes", value: "" },
                                                    });
                                                }
                                            }}
                                        />
                                        {/* <Input className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                             type="text" value={formData?.hsCode || ''} onChange={(e) => handleInputChange({ target: { name: 'hsCode', value: e.target.value } })} /> */}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Haz Cargo:
                                        </label>
                                        <div className="flex items-center space-x-6 mt-2">
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="hazCargo"
                                                    value={true}
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.hazCargo === true}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: { name: "hazCargo", value: true },
                                                        })
                                                    }
                                                />
                                                <span className="text-sm">Yes</span>
                                            </label>
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="hazCargo"
                                                    value={false}
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.hazCargo === false}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: { name: "hazCargo", value: false },
                                                        })
                                                    }
                                                />
                                                <span className="text-sm">No</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 col-span-2">
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                                IMO CLASS:
                                            </label>
                                            <Input
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="text"
                                                value={formData?.hazImoClass || ""}
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: {
                                                            name: "hazImoClass",
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                                PKG #:
                                            </label>
                                            <Input
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="text"
                                                value={formData?.hazPkg || ""}
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: { name: "hazPkg", value: e.target.value },
                                                    })
                                                }
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                                UN NBR:
                                            </label>
                                            <Input
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="text"
                                                value={formData?.hazUnNbr || ""}
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: {
                                                            name: "hazUnNbr",
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 col-span-2 items-end">
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                                WEIGHT:
                                            </label>
                                            <select
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                value={formData?.weightMetricId || ""}
                                                onChange={(e) => {
                                                    handleInputChange({
                                                        target: {
                                                            name: "weightMetricId",
                                                            value: e.target.value,
                                                        },
                                                    });
                                                    handleInputChange({
                                                        target: {
                                                            name: "weightMetricType",
                                                            value:
                                                                e.target.options[e.target.selectedIndex].text,
                                                        },
                                                    });
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {quantityTypeList?.map((quantity, key) => (
                                                    <option key={key} value={quantity.id}>
                                                        {quantity.incoterm}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <Input
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="number"
                                                value={formData?.weight || ""}
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: { name: "weight", value: e.target.value },
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label className="flex text-sm font-medium text-slate-600 dark:text-slate-400">
                                            Clauses Type:
                                        </label>

                                        <div className="flex flex-wrap items-center gap-2 mt-2">
                                            {[
                                                { label: "Auto", value: "A" },
                                                { label: "Reefer", value: "R" },
                                                { label: "Haz", value: "H" },
                                                { label: "None", value: "N" },
                                            ].map((item) => (
                                                <label
                                                    key={item.value}
                                                    className="flex items-center gap-1 px-1 py-1 rounded-lg cursor-pointer transition-all hover:border-blue-500"
                                                >
                                                    <input
                                                        type="radio"
                                                        name="clausesType"
                                                        value={item.value}
                                                        className="text-blue-600 focus:ring-blue-500"
                                                        checked={formData?.clausesType === item.value}
                                                        onChange={(e) =>
                                                            handleInputChange({
                                                                target: {
                                                                    name: "clausesType",
                                                                    value: e.target.value,
                                                                },
                                                            })
                                                        }
                                                    />
                                                    <span className="text-sm text-slate-700 dark:text-slate-300">
                                                        {item.label}
                                                    </span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                    {/* <div>
                      <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-3">
                        Document Request To Customer:
                      </label>
                      <Input
                        type="checkbox"
                        className="w-[15px] h-[15px]"
                        checked={formData?.documentRequestToCustomer}
                        onChange={(e) =>
                          handleInputChange({
                            target: {
                              name: "documentRequestToCustomer",
                              value: e.target.checked,
                            },
                          })
                        }
                      />
                    </div> */}
                                </div>
                                <div>
                                    <label
                                        className={`mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-md border cursor-pointer transition-all duration-200
    ${formData?.documentRequestToCustomer
                                                ? "bg-blue-50 border-blue-400 dark:bg-blue-900/30 dark:border-blue-500"
                                                : "border-gray-300 dark:bg-slate-800 dark:border-slate-700 hover:bg-gray-200 dark:hover:bg-slate-700"
                                            }`}
                                    >
                                        <input
                                            type="checkbox"
                                            name="documentRequestToCustomer"
                                            checked={formData?.documentRequestToCustomer}
                                            onChange={handleInputChange}
                                            className="accent-[#0072FF] w-3 h-3"
                                        />

                                        <span
                                            className={`text-xs font-medium ${formData?.documentRequestToCustomer
                                                ? "text-blue-700 dark:text-blue-400"
                                                : "text-slate-800 dark:text-slate-300"
                                                }`}
                                        >
                                            DOCUMENT REQUEST TO CUSTOMER
                                        </span>
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>
                    {/* Container Information */}
                    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                        <SectionHeader
                            icon={Container}
                            title="Container Information"
                            section="commodity"
                        />

                        {expandedSections.commodity && (
                            <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 col-span-2 items-end">
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                                Container
                                            </label>
                                            <Input
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="number"
                                                value={formData?.containerCount || ""}
                                                name="containerCount"
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerCount",
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                                min="0"
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault(); // letters block
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <select
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF] mt-2"
                                                value={formData?.containerTypeId || ""}
                                                onChange={(e) => {
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerTypeId",
                                                            value: e.target.value,
                                                        },
                                                    });
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerType",
                                                            value:
                                                                e.target.options[e.target.selectedIndex].text,
                                                        },
                                                    });
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {containerTypeList?.map((container, key) => (
                                                    <option key={key} value={container.moveTypeId}>
                                                        {container.moveType}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="hidden">
                                            <Input
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="text"
                                                value={formData?.containerTypeId || ""}
                                                readOnly
                                            />
                                        </div>
                                        <div className="">
                                            <Button
                                                variant={"outline"}
                                                onClick={() => {
                                                    handleInputChange({
                                                        target: { name: "containerCount", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "containerTypeId", value: "0" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "containerType", value: "" },
                                                    });
                                                }}
                                            >
                                                <Trash2 />
                                            </Button>
                                        </div>

                                        {/* row 2 */}
                                        <div>
                                            <Input
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="number"
                                                name="containerCount"
                                                value={formData?.containerCount1 || ""}
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerCount1",
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                                min="0"
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault(); // letters block
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <select
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF] mt-2"
                                                value={formData?.containerTypeId1 || ""}
                                                onChange={(e) => {
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerTypeId1",
                                                            value: e.target.value,
                                                        },
                                                    });
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerType1",
                                                            value:
                                                                e.target.options[e.target.selectedIndex].text,
                                                        },
                                                    });
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {containerTypeList?.map((container, key) => (
                                                    <option key={key} value={container.moveTypeId}>
                                                        {container.moveType}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="">
                                            <Button
                                                variant={"outline"}
                                                onClick={() => {
                                                    handleInputChange({
                                                        target: { name: "containerCount1", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "containerTypeId1", value: "0" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "containerType1", value: "" },
                                                    });
                                                }}
                                            >
                                                <Trash2 />
                                            </Button>
                                        </div>

                                        {/* row 3 */}
                                        <div>
                                            <Input
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                type="number"
                                                name="containerCount"
                                                value={formData?.containerCount2 || ""}
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerCount2",
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                                min="0"
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault(); // letters block
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <select
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF] mt-2"
                                                value={formData?.containerTypeId2 || ""}
                                                onChange={(e) => {
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerTypeId2",
                                                            value: e.target.value,
                                                        },
                                                    });
                                                    handleInputChange({
                                                        target: {
                                                            name: "containerType2",
                                                            value:
                                                                e.target.options[e.target.selectedIndex].text,
                                                        },
                                                    });
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {containerTypeList?.map((container, key) => (
                                                    <option key={key} value={container.moveTypeId}>
                                                        {container.moveType}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="">
                                            <Button
                                                variant={"outline"}
                                                onClick={() => {
                                                    handleInputChange({
                                                        target: { name: "containerCount2", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "containerTypeId2", value: "0" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "containerType2", value: "" },
                                                    });
                                                }}
                                            >
                                                <Trash2 />
                                            </Button>
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Reefer Container (Temperature):
                                        </label>
                                        <Input
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            type="number"
                                            value={formData?.reeferContainerTemperature || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "reeferContainerTemperature",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Temp UOM:
                                        </label>
                                        <Input
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            type="text"
                                            value={formData?.tempUom || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: { name: "tempUom", value: e.target.value },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Vent Status:
                                        </label>
                                        <div className="flex items-center space-x-6 mt-2">
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="ventstatus"
                                                    value="OPEN"
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.ventStatus === "OPEN"}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: { name: "ventStatus", value: "OPEN" },
                                                        })
                                                    }
                                                />
                                                <span className="text-sm">Open</span>
                                            </label>
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="ventstatus"
                                                    value="CLOSED"
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.ventStatus === "CLOSED"}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: { name: "ventStatus", value: "CLOSED" },
                                                        })
                                                    }
                                                />
                                                <span className="text-sm">Closed</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Vent Remarks:
                                        </label>
                                        <Input
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            type="text"
                                            value={formData?.ventRemark || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "ventRemark",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="col-span-2">
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Reefer Equipment Attributes:
                                        </label>
                                        <Input
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            type="text"
                                            value={formData?.reeferEquipmentAttributes || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "reeferEquipmentAttributes",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Payment Mode Type:
                                        </label>

                                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2">
                                            <label className="flex items-center space-x-2 text-sm">
                                                <input
                                                    type="radio"
                                                    name="paymentmodetype"
                                                    value="PREPAID"
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.paymentModeType === "PREPAID"}
                                                    onChange={() =>
                                                        handleInputChange({
                                                            target: {
                                                                name: "paymentModeType",
                                                                value: "PREPAID",
                                                            },
                                                        })
                                                    }
                                                />
                                                <span>Prepaid</span>
                                            </label>

                                            <label className="flex items-center space-x-2 text-sm">
                                                <input
                                                    type="radio"
                                                    name="paymentmodetype"
                                                    value="COLLECT"
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.paymentModeType === "COLLECT"}
                                                    onChange={() =>
                                                        handleInputChange({
                                                            target: {
                                                                name: "paymentModeType",
                                                                value: "COLLECT",
                                                            },
                                                        })
                                                    }
                                                />
                                                <span>Collect</span>
                                            </label>

                                            <label className="flex items-center space-x-2 text-sm">
                                                <input
                                                    type="radio"
                                                    name="paymentmodetype"
                                                    value="NOSTATUS"
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.paymentModeType === "NOSTATUS"}
                                                    onChange={() =>
                                                        handleInputChange({
                                                            target: {
                                                                name: "paymentModeType",
                                                                value: "NOSTATUS",
                                                            },
                                                        })
                                                    }
                                                />
                                                <span>No Status</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Payment Mode:
                                        </label>
                                        <Input
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            type="text"
                                            value={formData?.paymentMode}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "paymentMode",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Cargo Details (LCL/RO-RO) cargoDetails */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={Boxes}
                        title="Cargo Details (LCL/RO-RO)"
                        section="cargoDetails"
                    />

                    {expandedSections.cargoDetails && (
                        <div className="p-5 space-y-4 border-t border-slate-200 dark:border-slate-800">
                            {/* Purchase Order # lookup (mock) */}
                            <div className="flex flex-col gap-1">
                                <label className="text-sm font-medium text-slate-600 dark:text-slate-400">
                                    Purchase Order #<span className="text-red-500">*</span>
                                </label>
                                <div className="flex items-center gap-3">
                                    <Input
                                        type="text"
                                        value={poNumber}
                                        onChange={(e) => setPoNumber(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleSearchPurchaseOrder();
                                            }
                                        }}
                                        placeholder="e.g. PO12101508"
                                        data-testid="po-number-input"
                                        className="flex-1 px-4 py-2.5 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] outline-none transition"
                                    />
                                    <button
                                        type="button"
                                        onClick={handleSearchPurchaseOrder}
                                        data-testid="search-po-btn"
                                        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm shadow-sm transition-colors whitespace-nowrap flex-shrink-0"
                                    >
                                        <Search className="w-4 h-4" />
                                        Search Purchase Order Details
                                    </button>
                                </div>
                            </div>

                            {/* Package Details Section */}
                            <div className="grid grid-cols-1 md:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                {/* Package Count */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-slate-600 dark:text-slate-400">
                                        Piece
                                    </label>

                                    <Input
                                        className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        type="number"
                                        value={formData?.totalPackageType || ""}
                                        onChange={(e) =>
                                            handleInputChange({
                                                target: {
                                                    name: "totalPackageType",
                                                    value: e.target.value,
                                                },
                                            })
                                        }
                                        placeholder="0"
                                        min="0"
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault(); // letters block
                                            }
                                        }}
                                    />
                                </div>

                                {/* Package Type */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-slate-600 dark:text-slate-400">
                                        Package Type
                                    </label>
                                    <select
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-700 rounded-md text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#0072FF] focus:border-transparent"
                                        value={formData?.packageType || ""}
                                        onChange={(e) =>
                                            handleInputChange({
                                                target: { name: "packageType", value: e.target.value },
                                            })
                                        }
                                    >
                                        <option value="">Select type</option>
                                        <option value="carton">Carton</option>
                                        <option value="pallet">Pallet</option>
                                        <option value="crate">Crate</option>
                                        <option value="drum">Drum</option>
                                        <option value="bundle">Bundle</option>
                                        <option value="bag">Bag</option>
                                        <option value="box">Box</option>
                                        <option value="piece">Piece</option>
                                    </select>
                                </div>

                                {/* Description */}
                                {/* <div className="space-y-2 display: none;">
                                        <label className="text-sm font-medium text-slate-600 dark:text-slate-400">Description</label>
                                        <textarea
                                            className="w-full px-3 py-2 border border-slate-300 dark:border-slate-700 rounded-md text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#0072FF] focus:border-transparent"
                                            rows="2"
                                            value={formData?.cargoDescription || ''}
                                            onChange={(e) => handleInputChange({ target: { name: 'cargoDescription', value: e.target.value } })}
                                            placeholder="Cargo description"
                                        />
                                    </div> */}
                                <div>
                                    <label
                                        className={` mt-9 inline-flex items-center gap-2 px-3 py-1.5 rounded-md border cursor-pointer transition-all duration-200
    ${formData?.autoCalculate
                                                ? "bg-blue-50 border-blue-400 dark:bg-blue-900/30 dark:border-blue-500"
                                                : "border-gray-300 dark:bg-slate-800 dark:border-slate-700 hover:bg-gray-200 dark:hover:bg-slate-700"
                                            }`}
                                    >
                                        <input
                                            type="checkbox"
                                            name="autoCalculate"
                                            checked={formData?.autoCalculate || true}
                                            onChange={handleInputChange}
                                            className="accent-[#0072FF] w-3 h-3"
                                        />

                                        <span
                                            className={`text-xs font-medium ${formData?.autoCalculate
                                                ? "text-blue-700 dark:text-blue-400"
                                                : "text-slate-800 dark:text-slate-300"
                                                }`}
                                        >
                                            AUTO CALCULATE CBM, CFT & LBS
                                        </span>
                                    </label>
                                </div>
                                {/* <div>
                      <label className="mt-1 block text-sm font-medium text-slate-600 dark:text-slate-400 mb-3">
                         Auto Calculate CBM, CFT & LBS 
                      </label>
                      <Input
                        type="checkbox"
                        className="w-[15px] h-[15px]"
                        checked={formData?.autoCalculate || true}
                        onChange={(e) =>
                          handleInputChange({
                            target: {
                              name: "autoCalculate",
                              value: e.target.checked,
                            },
                          })
                        }
                      />
                    </div> */}
                            </div>

                            {/* Auto Calculate Toggle */}

                            {/* Cargo Items Table */}
                            <div className="overflow-x-auto border border-slate-200 dark:border-slate-700 rounded-lg">
                                <table className="w-full text-sm">
                                    <thead>
                                        <tr className="bg-slate-50 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-700">
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                Piece
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                Length
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                Width
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                Height
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                Package Type
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                Type
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                CBM
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                CFT
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                Wt (KGS)
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400">
                                                Wt (LBS)
                                            </th>
                                            <th className="text-left py-3 px-3 font-semibold text-slate-600 dark:text-slate-400"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cargoItems
                                            .filter((item) => !item.isDeleted)
                                            .map((item, index) => (
                                                <tr
                                                    key={index}
                                                    className="border-b border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800/30"
                                                >
                                                    {/* Piece */}
                                                    <td className="py-2 px-3">
                                                        <Input
                                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                            type="number"
                                                            value={item.piece || ""}
                                                            onChange={(e) =>
                                                                handleCargoItemChange(
                                                                    index,
                                                                    "piece",
                                                                    e.target.value,
                                                                )
                                                            }
                                                            min="0"
                                                            placeholder="0"
                                                        />
                                                    </td>

                                                    {/* Length */}
                                                    <td className="py-2 px-3">
                                                        <Input
                                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                            type="number"
                                                            value={item.length || ""}
                                                            onChange={(e) =>
                                                                handleCargoItemChange(
                                                                    index,
                                                                    "length",
                                                                    e.target.value,
                                                                )
                                                            }
                                                            min="0"
                                                            step="0.01"
                                                            placeholder="0.00"
                                                        />
                                                    </td>

                                                    {/* Width */}
                                                    <td className="py-2 px-3">
                                                        <Input
                                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                            type="number"
                                                            value={item.width || ""}
                                                            onChange={(e) =>
                                                                handleCargoItemChange(
                                                                    index,
                                                                    "width",
                                                                    e.target.value,
                                                                )
                                                            }
                                                            min="0"
                                                            step="0.01"
                                                            placeholder="0.00"
                                                        />
                                                    </td>

                                                    {/* Height */}
                                                    <td className="py-2 px-3">
                                                        <Input
                                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                            type="number"
                                                            value={item.height || ""}
                                                            onChange={(e) =>
                                                                handleCargoItemChange(
                                                                    index,
                                                                    "height",
                                                                    e.target.value,
                                                                )
                                                            }
                                                            min="0"
                                                            step="0.01"
                                                            placeholder="0.00"
                                                        />
                                                    </td>

                                                    {/*Package Type */}
                                                    <td className="py-2 px-3">
                                                        <select
                                                            className="w-24 px-2 py-1 border border-slate-300 dark:border-slate-700 rounded text-sm bg-white dark:bg-slate-800 focus:outline-none focus:ring-1 focus:ring-[#0072FF]"
                                                            value={item.packageType || ""}
                                                            onChange={(e) =>
                                                                handleCargoItemChange(
                                                                    index,
                                                                    "packageType",
                                                                    e.target.value,
                                                                )
                                                            }
                                                        >
                                                            <option value="">Select type</option>
                                                            <option value="carton">Carton</option>
                                                            <option value="pallet">Pallet</option>
                                                            <option value="crate">Crate</option>
                                                            <option value="drum">Drum</option>
                                                            <option value="bundle">Bundle</option>
                                                            <option value="bag">Bag</option>
                                                            <option value="box">Box</option>
                                                            <option value="piece">Piece</option>
                                                        </select>
                                                    </td>

                                                    {/*  Type */}
                                                    <td className="py-2 px-3">
                                                        <select
                                                            className="w-24 px-2 py-1 border border-slate-300 dark:border-slate-700 rounded text-sm bg-white dark:bg-slate-800 focus:outline-none focus:ring-1 focus:ring-[#0072FF]"
                                                            value={item.dimensionType || "METER"}
                                                            onChange={(e) =>
                                                                handleCargoItemChange(
                                                                    index,
                                                                    "dimensionType",
                                                                    e.target.value,
                                                                )
                                                            }
                                                        >
                                                            <option value="INCH">INCH</option>
                                                            <option value="CM">CM</option>
                                                            <option value="METER">METER</option>
                                                        </select>
                                                    </td>

                                                    {/* CBM */}
                                                    <td className="py-2 px-3">
                                                        <Input
                                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                            type="number"
                                                            value={item.cbm || ""}
                                                            readOnly
                                                            placeholder="0.00"
                                                        />
                                                    </td>

                                                    {/* CFT */}
                                                    <td className="py-2 px-3">
                                                        <Input
                                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                            type="number"
                                                            value={item.cft || ""}
                                                            readOnly
                                                            placeholder="0.00"
                                                        />
                                                    </td>

                                                    {/* Weight KGS */}
                                                    <td className="py-2 px-3">
                                                        <Input
                                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                            type="number"
                                                            value={item.weightKgs || ""}
                                                            onChange={(e) =>
                                                                handleCargoItemChange(
                                                                    index,
                                                                    "weightKgs",
                                                                    e.target.value,
                                                                )
                                                            }
                                                            min="0"
                                                            step="0.01"
                                                            placeholder="0.00"
                                                        />
                                                    </td>

                                                    {/* Weight LBS */}
                                                    <td className="py-2 px-3">
                                                        <Input
                                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                            type="number"
                                                            value={item.weightLbs || ""}
                                                            readOnly
                                                            placeholder="0.00"
                                                        />
                                                    </td>

                                                    {/* Delete Button */}
                                                    <td className="py-2 px-3">
                                                        <button
                                                            type="button"
                                                            onClick={() => removeCargoRow(index)}
                                                            className="inline-flex items-center justify-center h-8 w-8 text-red-600 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20 rounded transition-colors"
                                                            disabled={cargoItems.length === 1}
                                                        >
                                                            <Trash2 className="w-4 h-4" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Add More Row Button */}
                            <button
                                type="button"
                                onClick={addCargoRow}
                                className="flex items-center gap-2 p-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm transition-all duration-200"
                            >
                                <Plus className="w-4 h-4" />
                                <span className="text-sm font-small">Add More Row</span>
                            </button>
                            {/* Summary Table */}
                            <div className="overflow-x-auto border border-slate-200 dark:border-slate-700 rounded-lg">
                                <table className="w-full text-sm">
                                    <thead>
                                        <tr className="bg-slate-50 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-700">
                                            <th className="text-center py-3 px-4 font-semibold text-slate-600 dark:text-slate-400">
                                                Total Pieces
                                            </th>
                                            <th className="text-center py-3 px-4 font-semibold text-slate-600 dark:text-slate-400">
                                                Total Wt. LBS
                                            </th>
                                            <th className="text-center py-3 px-4 font-semibold text-slate-600 dark:text-slate-400">
                                                Total Wt. KGS
                                            </th>
                                            <th className="text-center py-3 px-4 font-semibold text-slate-600 dark:text-slate-400">
                                                Total Volume - CFT
                                            </th>
                                            <th className="text-center py-3 px-4 font-semibold text-slate-600 dark:text-slate-400">
                                                Total Volume - CBM
                                            </th>
                                            <th className="text-center py-3 px-4 font-semibold text-slate-600 dark:text-slate-400">
                                                Density (KG/CBM)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="bg-slate-50 dark:bg-slate-800/30">
                                            <td className="py-3 px-4 text-center">
                                                <div className="inline-block bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded px-4 py-1.5 font-medium">
                                                    {totalPieces}
                                                </div>
                                            </td>
                                            <td className="py-3 px-4 text-center">
                                                <div className="inline-block bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded px-4 py-1.5 font-medium">
                                                    {totalWeightLbs}
                                                </div>
                                            </td>
                                            <td className="py-3 px-4 text-center">
                                                <div className="inline-block bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded px-4 py-1.5 font-medium">
                                                    {totalWeightKgs}
                                                </div>
                                            </td>
                                            <td className="py-3 px-4 text-center">
                                                <div className="inline-block bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded px-4 py-1.5 font-medium text-blue-600 dark:text-blue-300">
                                                    {totalVolumeCft}
                                                </div>
                                            </td>
                                            <td className="py-3 px-4 text-center">
                                                <div className="inline-block bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded px-4 py-1.5 font-medium text-blue-600 dark:text-blue-300">
                                                    {totalVolumeCbm}
                                                </div>
                                            </td>
                                            <td className="py-3 px-4 text-center">
                                                <div className="inline-block bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded px-4 py-1.5 font-medium">
                                                    {density}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>

                {/* Trucking Instructions */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={Truck}
                        title="Trucking Instructions"
                        section="Trucking"
                    />

                    {expandedSections.Trucking && (
                        <div className="p-5 border-t border-slate-200 dark:border-slate-800">
                            <div className="grid grid-cols-3 gap-6 items-start">
                                {/* ── Column 1 ── */}
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Trucker:
                                        </label>
                                        <SearchBar
                                            searchAPI="v1/AutoSuggestion/GetTruckerAndTowing?Prefix="
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "trucker", value: d?.[1] },
                                                });
                                            }}
                                            value={formData?.trucker}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "trucker", value: "" },
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="flex flex-wrap gap-4">
                                        <label className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border cursor-pointer transition-all duration-200 border-gray-300 dark:bg-slate-800 dark:border-slate-700 hover:bg-gray-200 dark:hover:bg-slate-700">
                                            <input
                                                type="checkbox"
                                                name="hideTruckerOnBookingPrint"
                                                checked={formData?.hideTruckerOnBookingPrint}
                                                onChange={handleInputChange}
                                                className="accent-[#0072FF] w-3.5 h-3.5"
                                            />
                                            <span className="text-xs font-medium text-slate-700 dark:text-slate-300">
                                                Trucker Hide on Booking Print
                                            </span>
                                        </label>
                                        <label className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border cursor-pointer transition-all duration-200 border-gray-300 dark:bg-slate-800 dark:border-slate-700 hover:bg-gray-200 dark:hover:bg-slate-700">
                                            <input
                                                type="checkbox"
                                                name="truckerApptConfirmed"
                                                checked={formData?.truckerApptConfirmed}
                                                onChange={handleInputChange}
                                                className="accent-[#0072FF] w-3.5 h-3.5"
                                            />
                                            <span className="text-xs font-medium text-slate-700 dark:text-slate-300">
                                                Trucker appt confirmed
                                            </span>
                                        </label>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Rate Agreed:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.rateAgreed}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: { name: "rateAgreed", value: e.target.value },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Rate Agreed for wait time/hour:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.rateAgreedForWaiting}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "rateAgreedForWaiting",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                                Container:
                                            </label>
                                            <Input
                                                type="number"
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                value={formData?.truckerContainerCount}
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: {
                                                            name: "truckerContainerCount",
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                                Container Type:
                                            </label>
                                            <select
                                                className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                                value={formData?.truckerContainerTypeId || ""}
                                                onChange={(e) => {
                                                    handleInputChange({
                                                        target: {
                                                            name: "truckerContainerTypeId",
                                                            value: e.target.value,
                                                        },
                                                    });
                                                    handleInputChange({
                                                        target: {
                                                            name: "truckerContainerType",
                                                            value:
                                                                e.target.options[e.target.selectedIndex].text,
                                                        },
                                                    });
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {containerTypeList?.map((container, key) => (
                                                    <option key={key} value={container.moveTypeId}>
                                                        {container.moveType}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Empty Container Pickup:
                                        </label>
                                        <SearchBar
                                            searchAPI="v1/AutoSuggestion/GetTruckerAndTowing?Prefix="
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: {
                                                        name: "truckerEmptyContainerPickup",
                                                        value: d?.[1],
                                                    },
                                                });
                                                handleInputChange({
                                                    target: {
                                                        name: "truckerEmptyContainerPickupId",
                                                        value: d?.[0],
                                                    },
                                                });
                                                _setAddress(
                                                    "truckerEmptyContainerPickupAddress",
                                                    d?.[0],
                                                );
                                            }}
                                            value={formData?.truckerEmptyContainerPickup}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: {
                                                            name: "truckerEmptyContainerPickup",
                                                            value: "",
                                                        },
                                                    });
                                                    handleInputChange({
                                                        target: {
                                                            name: "truckerEmptyContainerPickupId",
                                                            value: 0,
                                                        },
                                                    });
                                                }
                                            }}
                                        />
                                        <Textarea
                                            className="mt-2 w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            rows="3"
                                            value={formData?.truckerEmptyContainerPickupAddress}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                                Earliest Pickup Date:
                                            </label>
                                            <DateInputwithcal
                                                name="truckerEarliestPickup"
                                                value={formData?.truckerEarliestPickup}
                                                onChange={handleDateChange}
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                                Earliest Recvd Date:
                                            </label>
                                            <DateInputwithcal
                                                name="truckerEarliestRecvd"
                                                value={formData?.truckerEarliestRecvd}
                                                onChange={handleDateChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* ── Column 2 ── */}
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Latest Delivery Date:
                                        </label>
                                        <DateInputwithcal
                                            name="truckerLatestDeliveryDate"
                                            value={formData?.truckerLatestDeliveryDate}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                    <div>
                                        <div className="flex items-center gap-2 mb-1.5">
                                            <label className="block text-sm font-medium text-slate-600 dark:text-slate-400">
                                                Container Return To:
                                            </label>
                                            <input
                                                type="checkbox"
                                                checked={sameAsEmptyContainer}
                                                onChange={handleSameAsEmptyContainerChange}
                                                className="h-4 w-4 text-blue-600 rounded"
                                            />
                                            <label className="text-sm font-medium text-slate-600 dark:text-slate-400">
                                                Same as Empty Container
                                            </label>
                                        </div>
                                        <SearchBar
                                            searchAPI="v1/AutoSuggestion/GetTruckerAndTowing?Prefix="
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: {
                                                        name: "truckerContainerReturnTo",
                                                        value: d?.[1],
                                                    },
                                                });
                                                handleInputChange({
                                                    target: {
                                                        name: "truckerContainerReturnToId",
                                                        value: d?.[0],
                                                    },
                                                });
                                                _setAddress("truckerContainerReturnToAddress", d?.[0]);
                                            }}
                                            value={formData?.truckerContainerReturnTo}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: {
                                                            name: "truckerContainerReturnTo",
                                                            value: "",
                                                        },
                                                    });
                                                    handleInputChange({
                                                        target: {
                                                            name: "truckerContainerReturnToId",
                                                            value: 0,
                                                        },
                                                    });
                                                }
                                            }}
                                        />
                                        <Textarea
                                            className="mt-2 w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            rows="3"
                                            value={formData?.truckerContainerReturnToAddress}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Cargo Description:
                                        </label>
                                        <Textarea
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            rows="3"
                                            value={formData?.cargoDescription || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "cargoDescription",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Trucker Instructions:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.warehouseInstructionsRemarks || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "warehouseInstructionsRemarks",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="hidden">
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Health Cert No:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.healthCertNo || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "healthCertNo",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            PO Number:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.poNumber || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: { name: "poNumber", value: e.target.value },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Loading Status:
                                        </label>
                                        <div className="flex items-center space-x-6">
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="loadingStatus"
                                                    value="LIVE"
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.loadingStatus === "LIVE"}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: { name: "loadingStatus", value: "LIVE" },
                                                        })
                                                    }
                                                />
                                                <span className="text-sm">Live Loading</span>
                                            </label>
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="loadingStatus"
                                                    value="DROP_PICK"
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.loadingStatus === "DROP_PICK"}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: {
                                                                name: "loadingStatus",
                                                                value: "DROP_PICK",
                                                            },
                                                        })
                                                    }
                                                />
                                                <span className="text-sm">Drop & Pick</span>
                                            </label>
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="loadingStatus"
                                                    value="PENDING"
                                                    className="text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={formData?.loadingStatus === "PENDING"}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: {
                                                                name: "loadingStatus",
                                                                value: "PENDING",
                                                            },
                                                        })
                                                    }
                                                />
                                                <span className="text-sm">Pending</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Live Load Date:
                                        </label>
                                        <DateInputwithcal
                                            name="liveLoadDate"
                                            value={formData?.liveLoadDate}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Drop Date:
                                        </label>
                                        <DateInputwithcal
                                            name="dropDate"
                                            value={formData?.dropDate}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                </div>

                                {/* ── Column 3 ── */}
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Pickup Date:
                                        </label>
                                        <DateInputwithcal
                                            name="pickupDate"
                                            value={formData?.pickupDate}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Loading Location:
                                        </label>
                                        <SearchBar
                                            searchAPI="v1/AutoSuggestion/GetWarehouseSuggestion?Prefix="
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: {
                                                        name: "loadingLocationWarehouse",
                                                        value: d?.[1],
                                                    },
                                                });
                                                handleInputChange({
                                                    target: {
                                                        name: "loadingLocationWarehouseId",
                                                        value: d?.[0],
                                                    },
                                                });
                                                _setAddress("loadingLocationWarehouseAddress", d?.[0]);
                                            }}
                                            value={formData?.loadingLocationWarehouse}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: {
                                                            name: "loadingLocationWarehouse",
                                                            value: "",
                                                        },
                                                    });
                                                    handleInputChange({
                                                        target: {
                                                            name: "loadingLocationWarehouseId",
                                                            value: 0,
                                                        },
                                                    });
                                                }
                                            }}
                                        />
                                        <Textarea
                                            className="mt-2 w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            rows="3"
                                            value={formData?.loadingLocationWarehouseAddress || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "loadingLocationWarehouseAddress",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Load Loc Contact Person:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={
                                                formData?.loadingLocationWarehouseContactPerson || ""
                                            }
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "loadingLocationWarehouseContactPerson",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Loading Location Tel & Fax:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.loadingLocationWarehouseTelFax || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "loadingLocationWarehouseTelFax",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Loading Remarks For Trucker:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.loadingRemarksForTrucker || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "loadingRemarksForTrucker",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Trucker POC:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.truckerPoc || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: { name: "truckerPoc", value: e.target.value },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Trucker Phone:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.truckerPhone || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "truckerPhone",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1.5">
                                            Trucker Email:
                                        </label>
                                        <Input
                                            type="text"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                            value={formData?.truckerEmail || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "truckerEmail",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Warehouse Instructions */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={Warehouse}
                        title="Warehouse Instructions"
                        color="bg-slate-700"
                        section="warehouse"
                    />

                    {expandedSections.warehouse && (
                        <div className="p-4 border-t border-slate-200 dark:border-slate-800 space-y-6">
                            <div className="space-y-4">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Warehouse Name
                                        </label>
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetWarehouseSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "warehouseName", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: { name: "warehouseId", value: d?.[0] },
                                                });
                                            }}
                                            value={formData?.warehouseName || ""}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({
                                                        target: { name: "warehouseName", value: "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: "warehouseId", value: 0 },
                                                    });
                                                }
                                            }}
                                            placeholder="Search warehouse..."
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Warehouse Code
                                        </label>
                                        <Input
                                            type="text"
                                            value={formData?.warehouseCode || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "warehouseCode",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                            placeholder="Enter warehouse code"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Warehouse Address
                                        </label>
                                        <textarea
                                            className="w-full px-3 py-2 border border-slate-300 dark:border-slate-700 rounded-md text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#0072FF] focus:border-transparent"
                                            rows="3"
                                            value={formData?.warehouseAddress || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "warehouseAddress",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                            placeholder="Enter warehouse address"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Warehouse Contact
                                        </label>
                                        <Input
                                            type="text"
                                            value={formData?.warehouseContact || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "warehouseContact",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                            placeholder="Enter contact details"
                                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Scheduling Section */}
                            <div className="space-y-4">
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Receiving Date
                                        </label>
                                        <DateInputwithcal
                                            label="Receiving Date"
                                            name="receivingDate"
                                            value={
                                                formData?.receivingDate === ""
                                                    ? null
                                                    : formData?.receivingDate
                                            }
                                            onChange={handleDateChange}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Receiving Time
                                        </label>
                                        <Input
                                            type="time"
                                            value={formData?.receivingTime || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "receivingTime",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                            className="placeholder:text-slate-400 dark:placeholder:text-slate-500 bg-white dark:bg-slate-800"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                            Appointment Number
                                        </label>
                                        <Input
                                            type="text"
                                            value={formData?.appointmentNumber || ""}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "appointmentNumber",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                            placeholder="Appointment #"
                                            className="placeholder:text-slate-400 dark:placeholder:text-slate-500 bg-white dark:bg-slate-800"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Special Instructions Section */}
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                        Special Instructions
                                    </label>
                                    <textarea
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-700 rounded-md text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#0072FF] focus:border-transparent"
                                        rows="3"
                                        value={formData?.specialInstructions || ""}
                                        onChange={(e) =>
                                            handleInputChange({
                                                target: {
                                                    name: "specialInstructions",
                                                    value: e.target.value,
                                                },
                                            })
                                        }
                                        placeholder="Enter any special warehouse instructions"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* AR & AP Schema / Charges - New Implementation */}
                <ARAPChargesContainer
                    bookingId={formData?.id}
                    bookingNo={formData?.fileNumber}
                    arCharges={arCharges}
                    setArCharges={setArCharges}
                    apCharges={apCharges}
                    setApCharges={setApCharges}
                    currencyList={currency_list}
                    basisList={charges_basis_list}
                    containerList={containerTypeList}
                    chargeCodeList={[]}
                    customerId={formData?.shipperId}
                    customerName={formData?.customerName || formData?.shipper}
                />

                {/* document upload section... */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={FolderOpen}
                        title="Document & Attachments"
                        color="bg-amber-600"
                        section="documentsupload"
                    />

                    {expandedSections.documentsupload && (
                        <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                            {Number(formData?.id) > 0 ? (
                                !formData?.carrierBookingNumber ? (
                                    <div className="text-red-500 text-sm font-medium">
                                        Please enter Carrier Booking Number to upload documents.
                                    </div>
                                ) : (
                                    <FileUpload
                                        orderId={formData?.id}
                                        orderNum={formData?.fileNumber}
                                        type="booking"
                                    />
                                )
                            ) : (
                                <div className="text-red-500 text-sm font-medium">
                                    Please save the booking first to access document uploads.
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {/* Notes upload section... */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={Edit2}
                        badge={`Add Booking Note For File Reference Number: ${formData?.fileNumber || "NIE000185975"}`}
                        title="Notes"
                        color="bg-emerald-600"
                        section="NotesUpload"
                    />

                    {expandedSections.NotesUpload && (
                        <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                            {Number(formData?.id) > 0 ? (
                                <div className="p-4">
                                    <UploadNotes
                                        BookingID={formData?.id}
                                        RefNumber={formData?.fileNumber}
                                        type="Booking"
                                    />
                                </div>
                            ) : (
                                <div className="p-4 text-red-500 text-sm font-medium">
                                    Please save the booking first to access uploads notes.
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Common Clause Section */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200 mt-3">
                    <SectionHeader
                        icon={FileCheck2}
                        title="Clause"
                        color="bg-cyan-500"
                        section="commonClause"
                    />

                    {expandedSections.commonClause && (
                        <div className="border-t border-slate-200 dark:border-slate-800">
                            <div className="m-4 border rounded-lg overflow-auto">
                                {/* Header */}
                                <div className="grid grid-cols-12 gap-4 px-4 py-3 bg-gray-100 dark:bg-slate-800 sticky top-0 z-10">
                                    <div className="col-span-1 text-center text-xs font-semibold uppercase text-slate-500">
                                        Apply
                                    </div>
                                    <div className="col-span-3 text-xs font-semibold uppercase text-slate-500">
                                        Clause Type
                                    </div>
                                    <div className="col-span-7 text-xs font-semibold uppercase text-slate-500">
                                        Clause Description
                                    </div>
                                    <div className=" col-span-1  text-xs font-semibold uppercase text-slate-500">
                                        Status
                                    </div>
                                </div>

                                {/* Scrollable Body (4 rows height) */}

                                <div className="max-h-[240px] overflow-y-auto divide-y divide-slate-200 dark:divide-slate-700">
                                    {clauses?.length > 0 ? (
                                        clauses.map((clause, index) => (
                                            <div
                                                key={`clause-${clause.ClauseTypeDescriptionID}-${index}`}
                                                className="grid grid-cols-12 gap-4 px-4 py-3 items-center hover:bg-slate-50 dark:hover:bg-slate-800 transition"
                                            >
                                                {/* Apply */}
                                                <div className="col-span-1 flex justify-center">
                                                    <input
                                                        type="checkbox"
                                                        className="h-3 w-3 rounded border-slate-300 text-[#0072FF] focus:ring-[#0072FF]"
                                                        checked={clause.applied || false}
                                                        onChange={(e) =>
                                                            handleClauseChange(
                                                                clause.ClauseTypeDescriptionID,
                                                                "applied",
                                                                e.target.checked,
                                                            )
                                                        }
                                                    />
                                                </div>

                                                {/* Clause Type */}
                                                <div className="col-span-3 text-xs font-normal text-slate-800 dark:text-slate-100">
                                                    {clause.ClauseType}
                                                </div>

                                                {/* Clause Description with Tooltip */}
                                                <div className="col-span-6 relative group">
                                                    <p className="text-xs text-slate-600 dark:text-slate-400 truncate cursor-pointer">
                                                        {clause.ClauseDescription}
                                                    </p>

                                                    <div className="absolute left-0 top-full z-20 hidden group-hover:block w-[420px] p-3 mt-2 text-xs text-white bg-slate-900 rounded-md shadow-lg">
                                                        {clause.ClauseDescription}
                                                    </div>
                                                </div>

                                                {/* Status */}
                                                <div className="col-span-2 flex justify-end">
                                                    <span
                                                        className={`px-3 py-1 rounded-full text-xs font-semibold
                    ${clause.applied
                                                                ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                                                                : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                                                            }`}
                                                    >
                                                        {clause.applied ? "Applied" : "Not Applied"}
                                                    </span>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="py-6 text-center text-sm text-slate-500">
                                            Loading clauses...
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Additional Info */}
                <div className="hidden bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700  mt-2 hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={Shield}
                        title="Additional Info"
                        color="bg-cyan-500"
                        section="additionalInfo"
                    />

                    {expandedSections.additionalInfo && (
                        <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                                <div>
                                    <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                        Letter of Credit #
                                    </label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-700 rounded-md text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#0072FF] focus:border-transparent"
                                        value={formData?.letterOfCreditNumber || ""}
                                        onChange={(e) =>
                                            handleInputChange({
                                                target: {
                                                    name: "letterOfCreditNumber",
                                                    value: e.target.value,
                                                },
                                            })
                                        }
                                        placeholder="L/C Number"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                        L/C Issue Date
                                    </label>
                                    <DateInputwithcal
                                        label="L/C Issue Date"
                                        name="lcIssueDate"
                                        value={formData?.lcIssueDate}
                                        onChange={handleDateChange}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                        L/C Expiry Date
                                    </label>
                                    <DateInputwithcal
                                        label="L/C Expiry Date"
                                        name="lcExpiryDate"
                                        value={formData?.lcExpiryDate}
                                        onChange={handleDateChange}
                                    />
                                </div>
                            </div>
                            {/* Bottom Row: L/C Expiry Date and Insurance Company */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                        Insurance Policy #
                                    </label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-700 rounded-md text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#0072FF] focus:border-transparent"
                                        value={formData?.insurancePolicyNumber || ""}
                                        onChange={(e) =>
                                            handleInputChange({
                                                target: {
                                                    name: "insurancePolicyNumber",
                                                    value: e.target.value,
                                                },
                                            })
                                        }
                                        placeholder="Insurance policy number"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                        Insurance Company
                                    </label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-700 rounded-md text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#0072FF] focus:border-transparent"
                                        value={formData?.insuranceCompany || ""}
                                        onChange={(e) =>
                                            handleInputChange({
                                                target: {
                                                    name: "insuranceCompany",
                                                    value: e.target.value,
                                                },
                                            })
                                        }
                                        placeholder="Insurance company name"
                                    />
                                </div>
                            </div>

                            {/* Additional Notes - Full Width */}
                            <div className="mb-6 gap-4 mt-4">
                                <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                                    Additional Notes
                                </label>
                                <textarea
                                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-700 rounded-md text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#0072FF] focus:border-transparent"
                                    rows="3"
                                    value={formData?.additionalNotes || ""}
                                    onChange={(e) =>
                                        handleInputChange({
                                            target: {
                                                name: "additionalNotes",
                                                value: e.target.value,
                                            },
                                        })
                                    }
                                    placeholder="Any additional information"
                                />
                            </div>
                        </div>
                    )}
                </div>

                {/* Agent & Remarks */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader
                        icon={UsersRound}
                        title="Agent & Remarks"
                        color="bg-emerald-500"
                        section="agent"
                    />

                    {expandedSections.agent && (
                        <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                            <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                <div>
                                    <label className="mt-1 text-sm text-slate-600">
                                        Overseas Agent
                                    </label>
                                    <div className="mt-2">
                                        <SearchBar
                                            searchAPI={
                                                "v1/AutoSuggestion/GetVendorSuggestion?Prefix="
                                            }
                                            selectReacord={(d) => {
                                                handleInputChange({
                                                    target: { name: "overseasAgent", value: d?.[1] },
                                                });
                                                handleInputChange({
                                                    target: { name: "overseasAgentId", value: d?.[0] },
                                                });
                                                _setAddress("overseasAgentAddress", d?.[0]);
                                            }}
                                            value={formData?.overseasAgent || ""}
                                        />
                                    </div>
                                    <Textarea
                                        className="mt-2 w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        rows={4}
                                        value={formData?.overseasAgentAddress || ""}
                                        onChange={handleInputChange}
                                        name="overseasAgentAddress"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm text-slate-600 mt-2">
                                        Agent Remarks
                                    </label>
                                    <Textarea
                                        placeholder="Enter any remarks for the overseas agent..."
                                        className="mt-2 w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        rows={6}
                                        value={formData?.overseasAgentRemarks || ""}
                                        onChange={handleInputChange}
                                        name="overseasAgentRemarks"
                                    />
                                </div>
                                <div className="hidden">
                                    <label className="text-sm text-slate-600">
                                        CO/D Declaration
                                    </label>
                                    <Textarea
                                        placeholder="Enter CO/D declaration details..."
                                        className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        rows={6}
                                        value={formData?.cO_DDeclaration || ""}
                                        onChange={handleInputChange}
                                        name="cO_DDeclaration"
                                    />
                                </div>
                                {/* Customer Remarks */}

                                <div>
                                    <label className="block text-sm text-slate-600 mt-2">
                                        Customer Remarks
                                    </label>
                                    <Textarea
                                        placeholder="Enter any remarks from the customer..."
                                        className="mt-2 w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        rows={6}
                                        value={formData?.customerRemarks || ""}
                                        onChange={handleInputChange}
                                        name="customerRemarks"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                                {/* Customer Remarks */}
                                {/* <div className="rounded-xl overflow-hidden shadow-md border border-emerald-200 dark:border-emerald-800">
                                    <div className="bg-emerald-600 text-white px-4 py-2 text-sm font-semibold">
                                        Customer Remarks
                                    </div>
                                    <div className="bg-emerald-50 dark:bg-emerald-900/20 p-4">
                                        <Textarea
                                            rows={4}
                                            name="customerRemarks"
                                            value={formData?.customerRemarks || ''}
                                            onChange={handleInputChange}
                                            placeholder="Enter customer remarks..."
                                            className="w-full px-3 py-2 text-sm rounded-lg border border-emerald-300 
                   dark:border-slate-700 bg-white dark:bg-slate-800
                   focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                                        />
                                    </div>
                                </div> */}

                                {/* Internal Remarks */}

                                <div>
                                    <label className="block text-sm text-slate-600 mt-2">
                                        Internal Remarks
                                    </label>
                                    <Textarea
                                        placeholder="Enter any internal remarks for this booking..."
                                        className="mt-2 w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        rows={6}
                                        value={formData?.internalRemarks || ""}
                                        onChange={handleInputChange}
                                        name="internalRemarks"
                                    />
                                </div>

                                {/* SSL Remarks */}

                                <div>
                                    <label className="block text-sm text-slate-600 mt-2">
                                        SSL Remarks
                                    </label>
                                    <Textarea
                                        placeholder="Enter any remarks related to SSL..."
                                        className="mt-2 w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:ring-1 focus:ring-[#0072FF]"
                                        rows={6}
                                        value={formData?.sslRemarks || ""}
                                        onChange={handleInputChange}
                                        name="sslRemarks"
                                    />
                                </div>

                                {/* Rubber Stamp */}
                                <div className="rounded-xl overflow-hidden shadow-md border border-indigo-200 dark:border-indigo-800 hidden">
                                    <div className="bg-indigo-600 text-white px-4 py-2 text-sm font-semibold">
                                        Rubber Stamp
                                    </div>
                                    <div className="bg-indigo-50 dark:bg-indigo-900/20 p-4">
                                        <Textarea
                                            rows={4}
                                            name="rubberStamp"
                                            value={formData?.rubberStamp || ""}
                                            onChange={handleInputChange}
                                            placeholder="Enter rubber stamp details..."
                                            className="w-full px-3 py-2 text-sm rounded-lg border border-indigo-300 
                   dark:border-slate-700 bg-white dark:bg-slate-800
                   focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Bottom Actions */}
                <div className="p-3 bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-slate-800 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <div className="flex items-center justify-between">
                        <div className="text-sm text-slate-500 dark:text-slate-400">
                            <span className="text-red-500">*</span> Required fields must be
                            filled
                        </div>

                        <div className="flex items-center gap-1.5">
                            {/* Close — ghost variant */}
                            <button
                                onClick={() => onBack()}
                                className="inline-flex items-center gap-1.5 text-[12.5px] font-medium px-4 h-[40px] rounded-[9px] transition-all duration-150 text-slate-600 hover:bg-red-50"
                            >
                                <span className="w-[15px] h-[15px] flex-shrink-0 [&>svg]:w-full [&>svg]:h-full">
                                    <X />
                                </span>
                                <span className="hidden sm:inline">Cancel</span>
                            </button>

                            {/* Print — tertiary variant (edit mode only) */}
                            {Number(formData?.id) > 0 && (
                                <a
                                    href={`/booking/print/${btoa(formData?.id)}`}
                                    target="_blank"
                                    className="inline-flex items-center gap-1.5 text-[12.5px] font-medium px-4 h-[40px] rounded-[9px] transition-all duration-150 bg-slate-100 text-slate-600 border border-slate-200 hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600 dark:hover:bg-slate-600"
                                >
                                    <span className="w-[15px] h-[15px] flex-shrink-0 [&>svg]:w-full [&>svg]:h-full ">
                                        <Printer />
                                    </span>
                                    <span className="hidden sm:inline">Print</span>
                                </a>
                            )}

                            {/* divider */}
                            <div className="w-px h-6 bg-slate-200 mx-1" />

                            {/* Save — success variant */}
                            <CelebrationButton
                                onClick={() => handleSubmit()}
                                label="Submit Booking"
                                isSuccess={isAnimate}
                                isLoading={loader}
                                className="inline-flex items-center gap-1.5 text-[12.5px] font-medium px-4 h-[40px] rounded-[9px] transition-all duration-150 bg-green-500 text-white hover:bg-green-700"
                                icon={
                                    <span className="w-[15px] h-[15px] flex-shrink-0 [&>svg]:w-full [&>svg]:h-full">
                                        <Send />
                                    </span>
                                }
                            />
                        </div>
                    </div>
                </div>

                {showModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-3">
                        <div className="bg-white dark:bg-slate-800 p-4 sm:p-6 rounded-lg w-full sm:w-[90%] md:w-[80%] lg:w-[70%] max-w-4xl shadow-xl">
                            {/* Heading */}
                            <h2 className="text-lg sm:text-xl font-bold mb-4 text-center text-black dark:text-white">
                                Vessel List
                            </h2>

                            {/* Scroll Wrapper */}
                            <div className="max-h-[300px] overflow-auto border border-gray-300 dark:border-slate-600">
                                <table className="w-full table-fixed border-collapse text-center">
                                    {/* Header */}
                                    <thead className="bg-gray-200 dark:bg-slate-700 text-black dark:text-white sticky top-0 z-10">
                                        <tr>
                                            <th className="border p-2 w-[120px]">Action</th>
                                            <th className="border p-2 w-[30%]">Vessel</th>
                                            <th className="border p-2 w-[30%]">Voyage</th>
                                            <th className="border p-2 w-[30%]">ETD</th>
                                            <th className="border p-2 w-[30%]">ETA</th>
                                            <th className="border p-2 w-[30%]">Port C/O</th>
                                            <th className="border p-2 w-[30%]">TT</th>
                                        </tr>
                                    </thead>

                                    {/* Body */}
                                    <tbody>
                                        {vesselList.map((item, index) => (
                                            <tr
                                                key={index}
                                                className="bg-white dark:bg-slate-800 text-black dark:text-white hover:bg-gray-100 dark:hover:bg-slate-700"
                                            >
                                                <td className="border p-2 w-[120px]">
                                                    <button
                                                        onClick={() => handleSelectVessel(item)}
                                                        className="px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm"
                                                    >
                                                        Select
                                                    </button>
                                                </td>

                                                <td className="border p-2 break-words">
                                                    {item.vesselName}
                                                </td>
                                                <td className="border p-2 break-words">
                                                    {item.voyageNumber}
                                                </td>
                                                <td className="border p-2 break-words">
                                                    {item.originDepartureDate}
                                                </td>
                                                <td className="border p-2 break-words">
                                                    {item.destinationArrivalDate}
                                                </td>
                                                <td className="border p-2 break-words">
                                                    {item.terminalCutoff}
                                                </td>
                                                <td className="border p-2 break-words">
                                                    {item.totalDuration}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Footer */}
                            <div className="flex justify-center mt-4">
                                <button
                                    onClick={() => setShowModal(false)}
                                    className="px-4 py-1 bg-red-500 hover:bg-red-600 text-white rounded"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </form>

            {/* Purchase Order Cargo Info Modal */}
            {poModalOpen && poModalData && (
                <div
                    className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
                    onClick={() => setPoModalOpen(false)}
                    data-testid="po-cargo-modal"
                >
                    <div
                        className="bg-white dark:bg-slate-900 rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden border border-slate-200 dark:border-slate-700"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header */}
                        <div className="px-6 py-4 bg-[#0099dd] text-white flex items-center justify-between">
                            <h3 className="text-lg font-semibold">
                                Cargo Information for Purchase Order #:{" "}
                                <span className="font-bold">{poModalData.poNumber}</span>
                            </h3>
                            <button
                                type="button"
                                onClick={() => setPoModalOpen(false)}
                                className="p-1 rounded hover:bg-white/15"
                                data-testid="po-cargo-close"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>

                        {/* Body */}
                        <div className="p-0 overflow-auto max-h-[calc(90vh-140px)]">
                            <table className="w-full text-sm border-collapse">
                                <thead className="bg-blue-50 dark:bg-slate-800">
                                    <tr>
                                        <th className="px-3 py-2 text-center font-bold text-slate-700 dark:text-white border border-slate-300 dark:border-slate-700 uppercase text-xs">
                                            Load
                                        </th>
                                        <th className="px-3 py-2 text-left   font-bold text-slate-700 dark:text-white border border-slate-300 dark:border-slate-700 uppercase text-xs">
                                            Description
                                        </th>
                                        <th className="px-3 py-2 text-left   font-bold text-slate-700 dark:text-white border border-slate-300 dark:border-slate-700 uppercase text-xs">
                                            Item #
                                        </th>
                                        <th className="px-3 py-2 text-center font-bold text-slate-700 dark:text-white border border-slate-300 dark:border-slate-700 uppercase text-xs">
                                            Total Items
                                        </th>
                                        <th className="px-3 py-2 text-center font-bold text-slate-700 dark:text-white border border-slate-300 dark:border-slate-700 uppercase text-xs">
                                            Loaded
                                        </th>
                                        <th className="px-3 py-2 text-center font-bold text-slate-700 dark:text-white border border-slate-300 dark:border-slate-700 uppercase text-xs">
                                            Pending
                                        </th>
                                        <th className="px-3 py-2 text-center font-bold text-slate-700 dark:text-white border border-slate-300 dark:border-slate-700 uppercase text-xs">
                                            Ready To Load
                                        </th>
                                        <th className="px-3 py-2 text-center font-bold text-slate-700 dark:text-white border border-slate-300 dark:border-slate-700 uppercase text-xs">
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {poModalData.items.map((row, idx) => {
                                        const statusColor =
                                            row.status === "DONE"
                                                ? "text-green-600 font-bold"
                                                : row.status === "PENDING"
                                                    ? "text-red-600 font-bold"
                                                    : "text-amber-600 font-bold";
                                        return (
                                            <tr
                                                key={idx}
                                                className="bg-yellow-50 dark:bg-slate-800/40"
                                            >
                                                <td className="px-3 py-2 border border-slate-300 dark:border-slate-700 text-center">
                                                    <input
                                                        type="checkbox"
                                                        checked={!!poSelectedLoads[idx]}
                                                        onChange={(e) =>
                                                            setPoSelectedLoads((prev) => ({
                                                                ...prev,
                                                                [idx]: e.target.checked,
                                                            }))
                                                        }
                                                        data-testid={`po-load-checkbox-${idx}`}
                                                        className="w-4 h-4 accent-green-600"
                                                    />
                                                </td>
                                                <td className="px-3 py-2 border border-slate-300 dark:border-slate-700 text-slate-800 dark:text-white">
                                                    {row.description}
                                                </td>
                                                <td className="px-3 py-2 border border-slate-300 dark:border-slate-700 text-slate-800 dark:text-white">
                                                    {row.itemNo}
                                                </td>
                                                <td className="px-3 py-2 border border-slate-300 dark:border-slate-700 text-center text-blue-600 font-semibold">
                                                    {row.totalItems}
                                                </td>
                                                <td className="px-3 py-2 border border-slate-300 dark:border-slate-700 text-center text-green-600 font-semibold">
                                                    {row.loaded}
                                                </td>
                                                <td className="px-3 py-2 border border-slate-300 dark:border-slate-700 text-center text-red-600 font-semibold">
                                                    {row.pending}
                                                </td>
                                                <td className="px-3 py-2 border border-slate-300 dark:border-slate-700 text-center">
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        defaultValue={row.readyToLoad}
                                                        className="w-16 px-2 py-1 bg-yellow-200 dark:bg-amber-600/60 text-center text-slate-800 dark:text-white rounded border border-amber-400 focus:outline-none"
                                                    />
                                                </td>
                                                <td
                                                    className={`px-3 py-2 border border-slate-300 dark:border-slate-700 text-center ${statusColor}`}
                                                >
                                                    {row.status}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* Footer */}
                        <div className="px-6 py-3 border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/60 flex items-center justify-end gap-2">
                            <button
                                type="button"
                                onClick={() => {
                                    const selectedCount =
                                        Object.values(poSelectedLoads).filter(Boolean).length;
                                    toast.success(
                                        `Saved ${selectedCount} item(s) from ${poModalData.poNumber}`,
                                    );
                                    setPoModalOpen(false);
                                }}
                                data-testid="po-cargo-save"
                                className="px-5 py-2 rounded bg-red-500 hover:bg-red-600 text-white text-sm font-bold shadow-sm"
                            >
                                SAVE
                            </button>
                            <button
                                type="button"
                                onClick={() => setPoModalOpen(false)}
                                data-testid="po-cargo-close-btn"
                                className="px-5 py-2 rounded bg-green-500 hover:bg-green-600 text-white text-sm font-bold shadow-sm"
                            >
                                CLOSE
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BookingForm;
